/* eslint-disable */
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import $ from 'jquery';
import CKEditor from 'ckeditor4-react';
import Header from '../Layouts/Header';
import MenuSidebar from '../Layouts/MenuSidebar';
import { SketchPicker } from 'react-color'
import reactCSS from 'reactcss'
import { apiUrl, cmscontentURL,mediaUrl} from'../Config/Config';

import { GET_SETTINGDATA, GET_UPDATESETTING, GET_FONTNAME } from '../../actions';
import Select from 'react-select';
import axios from 'axios';
import { scrollToTopValidate, PageTitle,scrollToTop } from "../Helpers/SettingHelper";
import Addinputsimple from './Addinputsimple';
import { lang } from '../Helpers/lang';
import { ShadowPicker } from "react-shadow-picker";

class Setting extends Component {
	
	constructor(props)
	{
		super(props);	
		this.state = {
			settings_id:'',
			settings_site_title:'',
			settings_from_name:'',
			settings_admin_email:'',
			settings_from_email:'',
			notification_email: '',
			settings_mailpath:'',
			settings_company_address:'',
			settings_commission_percentage:'', 
			settings_smtp_host:'',
			settings_smtp_user:'',
			settings_smtp_pass:'',
			settings_smtp_port:'',
			settings_username:'',
			settings_mobileno:'',
			settings_email_footer:'',
			settings_commision_amount:'',
			merchant_commision_to_broker:'',
			lender_purchase_count:'',
			smtp_checked:false,
			Loading: false,
			displayColorPicker: false,
			color: {
			r: '241',
			g: '112',
			b: '19',
			a: '1',
			},
			hexColor:'#f17013',
			settings_public_key:'',
			settings_product_key:'',
			settings_secret_key:'',
			primary_font:'',
			main_tab_font_size:'',
			menu_font_size:'',
			stripe_live_checked:false,
			stripe_sandbox_checked:false,
			settings_embedcode:'',
			setting_goal_amount:'',
			settings_access_code:'',
			st_position_left:'',
			st_position_right:'',
			st_position_top:'',
			st_plugin_radius:'',
			st_plugin_height:'',
			st_dropdown_menu_radius:'',
			inputRadius:'',
			textareaRadius:'',
			st_position_bottom:'',
			domainSets:'',
			removeID:[
			],
			fonttype : [],
			selectedFont:'',
			fontvalue:'',
			st_position_checked:true,
			st_outer_space_checked:true,
			st_position:'fixed',
			supporter_additional_fee:'',
			product_layout2_checked:true,
			product_layout3_checked:false,
			google_analystic_code:'',
			category_icons_yes:true,
			category_icons_no:false,
			maintab_enable_yes:true,
			maintab_enable_no:false,
			terms_and_condition: '',
			np_theme:'',
			header_cat_limit:1,
			invite_friends_perc:1,
			count_domain:'',
			faqmodelcommon:[{"value":"gpt-3.5-turbo","label":"gpt-3.5-turbo"},{"value":"gpt-4-0613","label":"gpt-4-0613"}],
			faqmodelguest: '',
			faqmodeluser: '',
			faqmodelbroker: '',
			faqmodelcompany:'',
			faqmodellender:'',
			selectedfaqmodelcommonval:'',
			selectedfaqmodeluserval:'',
			selectedfaqmodelguestval:'',
			selectedfaqmodelbrokerval:'',
			selectedfaqmodelcompanyval:'',
			selectedfaqmodellenderval:'',
			selectedfaqmodelcommon:'',
			selectedfaqmodelguest:'',
			selectedfaqmodelbroker:'',
			selectedfaqmodelcompany:'',
			selectedfaqmodellender:'',
			selectedfaqmodeluserval:'',
			ai_fine_tune_model_id:'',
			aichat_type:"text",
			leads_tax:'',
			leads_purchase_amount:'',
			selectedOption:'',
			admin_id:localStorage.getItem('admin_id'),
			  module_type : localStorage.getItem("module_type"),
			  lender_invite_desc : '',
			  investor_invite_desc : '',
			  old_lender_invite_img : '',
			  old_investor_invite_img : '',
			  old_email_header_img : '',
			  description: '',
			  selectedFontVariant:'',
				st_varient_id: [],
				landing_page:'InnerTab',
				selectedChatmodule:"",
				chatmodulevalue:"",
				st_varient_id: [],
				st_inventory_count:"",
				fontDetails: [],
				shortcut_icons_yes:true,
				shortcut_icons_no:false,
				json_update_yes:true,
				json_update_no:false,
			finetune_content : '',
			completion_type : '',
			st_aisidebar_icon_width:'',
			st_aisidebar_main_width:'',
			st_aisidebar_collapsed_width:'',

			st_inner_position_top:"",
			st_inner_position_bottom:"",
			st_inner_position_left:"",
			st_inner_position_right:"",
			st_scalar_height:"",
            st_scalar_width:"",


			themeData : [],
			selTheme  : [],
			theme_id  : '',
			dashboard_view: "",
			lead_view: "",
			terms_services: "",
			capital_provider: "",
			privacy_policy: "",
			borrower_terms: "",
			crypto_terms: "",
			disclosure_policy_terms: "",
            guestuserfileupload:'',
			userfileupload:'',
			book_keepingfileupload:'',
			st_factor_rate:''
			// shadow:"0 18px 21px 0 #000",
			// shadows: {
			// 		pluginShadow:'0px 24px 34px #0404052e',
			// 		dashboardShadowGrid:'0 10px 21px 0 #0000001c',
			// 		dashboardShadowList:"0 21px 21px 0 #0000001c",
			// 		//sideMenu:"-2px 10px 15px #3434375e",
			// 		largeButton: '0 4px 18px 0 #0404052e',
			// 		//pluginInset: '5px 0px 15px 0 #3434372b',
			// 		// smallButton: '0 18px 21px 0 #000',
			// 		textarea: '0 7px 10px -7px #04040422',
			// 		//shortcutMenu: '0px 3px 21px 0px #9f99995c',
			// 		shadowListRow: "0px 15px 10px -15px #0404052e;",
			// 		shadowTableRow: "0px 15px 10px -15px #0404052e;",
			// 		dropdownmenu: '0px 3px 21px 0px #9f99995c',
			// 		shadowAISidebar: "5px 0px 15px 0 #3434372b",					
			// 		shadowPluginInsetLeft: "inset 15px 0 10px -10px #2727272b",
			// 		shadowPluginInsetRight: "inset -15px 0 10px -10px #2727272b",
			// 		shadowPluginInsetTop: "inset 0px 15px 10px -10px #2727272b",
			// 		shadowPluginInsetBottom: "inset 0px -15px 10px -10px #2727272b",
			// 		shadowInput: "5px 0px 5px 0px #3434372b",
			// 		shadowText: "0 7px 10px -7px #04040422",
			// 		shadowLeftSidebar: "0px 3px 21px 0px #9f99995c",
			// 		shadowRightSidebar: "0px 3px 21px 0px #9f99995c",
			// 		shadowMainAITextarea: "inset 5px 0px 5px 0px #3434372b",
			// 		shadowPluginOpenButtonInset: "inset 5px 0px 5px 0px #3434372b",

			// 		// sidePopup: '0 18px 21px 0 #000',
			// 	},
 
			// 	activeShadowType: 'largeButton'

 

		};		

		
		this.inputRef = React.createRef();
		var qs = require('qs');
		
		var postobject = {
			admin_id:  localStorage.getItem("admin_id")
		};

		//this.props.getSettingData(qs.stringify(postobject));

		axios.post(apiUrl+"adminpanel/adminsettings",qs.stringify(postobject)).then(res => {
				if(res.data.results){
					const formpayload = res.data.results;
					console.log(formpayload, "formpayload123")
				this.setState({finetune_content:res.data.finetune_content});
				this.setState({completion_type:res.data.completion_type});

					this.setState({settings_id:formpayload.settings_id});
					this.setState({st_inner_position_top:formpayload.st_inner_position_top});
					this.setState({st_inner_position_left:formpayload.st_inner_position_left});
					this.setState({st_inner_position_bottom:formpayload.st_inner_position_bottom});
					this.setState({st_inner_position_right:formpayload.st_inner_position_right});
					this.setState({st_scalar_height:formpayload.st_scalar_height !=0 ? formpayload.st_scalar_height : ''});
					this.setState({st_scalar_width:formpayload.st_scalar_width !=0 ? formpayload.st_scalar_width : ''});
					this.setState({old_scalar_img:formpayload.scalar_icon_image});
					this.setState({ dashboard_view: formpayload.dashboardview });
					this.setState({ lead_view: formpayload.leadsView });
					
					this.setState({ terms_services: formpayload.terms_services });
					this.setState({ capital_provider: formpayload.capital_provider });
					this.setState({ privacy_policy: formpayload.privacy_policy });
					this.setState({ borrower_terms: formpayload.borrower_terms });
					this.setState({ crypto_terms: formpayload.crypto_terms });
					this.setState({ disclosure_policy_terms: formpayload.disclosure_policy_terms });
			
					//this.setState({shadow:formpayload.settings_shadow});
					this.setState({st_aisidebar_icon_width:formpayload.st_aisidebar_icon_width});
					this.setState({st_aisidebar_main_width:formpayload.st_aisidebar_main_width});
					this.setState({st_aisidebar_collapsed_width:formpayload.st_aisidebar_collapsed_width});

	
					this.setState({ inputValue: formpayload.settings_shadow });
					this.setState({terms_and_condition:formpayload.settings_consent_content});
					this.setState({settings_site_title:formpayload.settings_site_title});
					this.setState({settings_from_name:formpayload.settings_from_name});
					this.setState({settings_admin_email:formpayload.settings_admin_email});
					this.setState({settings_from_email:formpayload.settings_from_email}); 
                    this.setState({notification_email:formpayload.notification_email}); 
					this.setState({settings_mailpath:formpayload.settings_mailpath});
					this.setState({settings_company_address:formpayload.settings_company_address});
					this.setState({settings_commission_percentage:formpayload.settings_commission_percentage});
					this.setState({settings_smtp_host:formpayload.settings_smtp_host});
					this.setState({settings_smtp_user:formpayload.settings_smtp_user});
					this.setState({settings_smtp_pass:formpayload.settings_smtp_pass});
					this.setState({settings_smtp_port:formpayload.settings_smtp_port});
					this.setState({settings_username:formpayload.settings_username});
					this.setState({settings_mobileno:formpayload.settings_mobileno});
					this.setState({settings_email_footer:formpayload.settings_email_footer});
					this.setState({hexColor:formpayload.settings_site_background_color});
					this.setState({settings_public_key:formpayload.settings_public_key});
					this.setState({settings_product_key:formpayload.settings_product_key});
					this.setState({setting_goal_amount:formpayload.setting_goal_amount});
					this.setState({supporter_additional_fee:formpayload.supporter_additional_fee});
					this.setState({settings_secret_key:formpayload.settings_secret_key});
					this.setState({primary_font:formpayload.primary_font});
					this.setState({main_tab_font_size:formpayload.main_tab_font_size});
					this.setState({menu_font_size:formpayload.menu_font_size});
					this.setState({lineHeight:formpayload.lineHeight});
					this.setState({settings_embedcode:formpayload.settings_embedcode});
					this.setState({settings_access_code:formpayload.access_code});				
					this.setState({st_position_left:formpayload.st_position_left});
					this.setState({st_position_right:formpayload.st_position_right});
					this.setState({st_position_top:formpayload.st_position_top});
					//this.setState({st_plugin_radius:formpayload.st_plugin_radius});
					this.setState({st_plugin_height:formpayload.st_plugin_height});
					//this.setState({st_dropdown_menu_radius:formpayload.st_dropdown_menu_radius});
					//this.setState({inputRadius:formpayload.inputRadius});
					//this.setState({textareaRadius:formpayload.textareaRadius});
					this.setState({st_position_bottom:formpayload.st_position_bottom});
					this.setState({domainSets : formpayload.domainSets});
					this.setState({settings_commision_amount: formpayload.settings_commision_amount});
					this.setState({merchant_commision_to_broker: formpayload.merchant_commision_to_broker});
					this.setState({lender_purchase_count: formpayload.lender_purchase_count});										
					this.setState({header_cat_limit: formpayload.header_cat_limit});
					this.setState({guestuserfileupload: formpayload.guestuserfileupload_limit});
					this.setState({userfileupload: formpayload.userfileupload_limit});
					this.setState({book_keepingfileupload: formpayload.book_keepingfileupload_limit});
					this.setState({st_factor_rate: formpayload.factor_rate});
					this.setState({np_theme: formpayload.notification_popup_theme});
					this.setState({invite_friends_perc: formpayload.invite_friends_perc});
					this.setState({leads_tax:formpayload.leads_tax});		
					this.setState({leads_purchase_amount:formpayload.leads_purchase_amount});		
					this.setState({lender_invite_desc:formpayload.lender_invitation_desc});		
					this.setState({investor_invite_desc:formpayload.investor_invitation_desc});			
					this.setState({chat_api_key:formpayload.chat_api_key});			
					
					this.setState({landing_page:formpayload.landing_page});

					this.setState({st_position: formpayload.st_plugin_position},()=>{
						if(formpayload.st_plugin_position =='absolute'){
							$('.d-height').removeClass('d-none');
						}else{
							$('.d-height').addClass('d-none');
						}
					});
					

					if(formpayload.lender_invitation_template !== null){
						this.setState({old_lender_invite_img:formpayload.lender_invitation_template});
					}
					if(formpayload.investor_invitation_template !== null){
						this.setState({old_investor_invite_img:formpayload.investor_invitation_template});
					}

					if(formpayload.email_header_image !== null){
						this.setState({old_email_header_img:formpayload.email_header_image});
					}
					if(formpayload.scalar_icon_image !== null){
						this.setState({old_scalar_icon_img:formpayload.scalar_icon_image});
					}

					if(formpayload.show_shortcut_icons === 'yes'){
						this.setState({shortcut_icons_yes: true });
						this.setState({shortcut_icons_no: false});
					}else{
						this.setState({shortcut_icons_no: true});
						this.setState({shortcut_icons_yes: false });
					}

					if(formpayload.settings_faq_common_model_id!== 'null' && formpayload.settings_faq_common_model_id !== ''){
						this.setState({selectedfaqmodelcommon: {value:formpayload.settings_faq_common_model_id, label:formpayload.settings_faq_common_model_id},selectedfaqmodelcommonval:formpayload.settings_faq_common_model_id });
					}
					if(formpayload.default_model_id!== 'null' && formpayload.default_model_id !== ''){
						this.setState({selectedChatmodule: {value:formpayload.default_model_id, label:formpayload.default_model_id},chatmodulevalue:formpayload.default_model_id });
					}
					if(formpayload.pluginwidth === '600'){
									
						this.setState({selectedOption:{value: '600', label: '600px'}});
						this.setState({pluginwidth_value:600});
						
					}else if(formpayload.pluginwidth === '700'){ 
						
						this.setState({selectedOption:{value: '700', label: '700px'}});
						this.setState({pluginwidth_value:700});
	
		
					}
					// else if(formpayload.pluginwidth === '630'){ 
					// 	this.setState({selectedOption:{value: '630', label: '630px'}});
					// 	this.setState({pluginwidth_value:630});	
					// }
					else if(formpayload.pluginwidth === '800'){ 
						
						this.setState({selectedOption:{value: '800', label: '800px'}});
						this.setState({pluginwidth_value:800});
	
		
					}else if(formpayload.pluginwidth === '900'){ 
						
						this.setState({selectedOption:{value: '900', label: '900px'}});
						this.setState({pluginwidth_value:900});
	
		
					}else if(formpayload.pluginwidth === '1000'){ 
						
						this.setState({selectedOption:{value: '1000', label: '1000px'}});
						this.setState({pluginwidth_value:1000});
	
		
					}

				if(res.data.themelist!== '' && res.data.themelist!== null){
					this.setselectedtheme(res.data.themelist);
				}

				if (res.data.setting_font_varients !== '' && res.data.setting_font_varients !== null) {
						this.setState({fontDetails:res.data.setting_font_varients});
				}else{
					this.setState({
						fontDetails: [
							{
							index: Math.random(),
							fontType: "",
							fontSize:'',
							fontWeight:'',
							letterSpacing:'',
							lineHeight:'',
							topSpace:'',
							bottomSpace:'',
							varient_id : "",
							}
						]
					});
				}
				

					if(formpayload.settings_faq_user_model_id!== 'null' && formpayload.settings_faq_user_model_id !== ''){
						this.setState({selectedfaqmodeluser: {value:formpayload.settings_faq_user_model_id, label:formpayload.settings_faq_user_model_id},selectedfaqmodeluserval:formpayload.settings_faq_user_model_id });
					}
					if(formpayload.settings_faq_guest_model_id!== 'null' && formpayload.settings_faq_guest_model_id !== ''){
						this.setState({selectedfaqmodelguest: {value:formpayload.settings_faq_guest_model_id, label:formpayload.settings_faq_guest_model_id},selectedfaqmodelguestval:formpayload.settings_faq_guest_model_id});
					}
					if(formpayload.settings_faq_doctor_model_id!== 'null' && formpayload.settings_faq_doctor_model_id !== ''){
						this.setState({selectedfaqmodelbroker: {value:formpayload.settings_faq_doctor_model_id, label:formpayload.settings_faq_doctor_model_id},selectedfaqmodelbrokerval:formpayload.settings_faq_doctor_model_id});
					}
					if(formpayload.settings_faq_company_model_id!== 'null' && formpayload.settings_faq_company_model_id !== ''){
						this.setState({selectedfaqmodelcompany: {value:formpayload.settings_faq_company_model_id, label:formpayload.settings_faq_company_model_id},selectedfaqmodelcompanyval:formpayload.settings_faq_company_model_id });
					}
					if(formpayload.settings_faq_technician_model_id!== 'null' && formpayload.settings_faq_technician_model_id !== ''){
						this.setState({selectedfaqmodellender: {value:formpayload.settings_faq_technician_model_id, label:formpayload.settings_faq_technician_model_id},selectedfaqmodellenderval:formpayload.settings_faq_technician_model_id });
					}
					this.setState({aichat_type: formpayload.ai_model_type});
					this.setState({ai_fine_tune_model_id: formpayload.ai_fine_tune_model_id});
	
					if( formpayload.google_analystic_code !== 'null'){
						this.setState({google_analystic_code: formpayload.google_analystic_code});
					}else{
						this.setState({google_analystic_code: ''});
					}
					
					if(formpayload.settings_mail_from_smtp === '1'){
						this.setState({smtp_checked: true});
					}else{
						this.setState({smtp_checked: false});
					}
					if(formpayload.pluginwidth === '600'){
									
						this.setState({selectedOption:{value: '600', label: '600px'}});
					}else if(formpayload.pluginwidth === '700'){ 
						
						this.setState({selectedOption:{value: '700', label: '700px'}});
		
					}else if(formpayload.pluginwidth === '630'){ 
						
						this.setState({selectedOption:{value: '630', label: '630px'}});
		
					}else if(formpayload.pluginwidth === '800'){ 
						
						this.setState({selectedOption:{value: '800', label: '800px'}});
		
					}else if(formpayload.pluginwidth === '900'){ 
						
						this.setState({selectedOption:{value: '900', label: '900px'}});
		
					}else if(formpayload.pluginwidth === '1000'){ 
						
						this.setState({selectedOption:{value: '1000', label: '1000px'}});
		
					}
					if(formpayload.enable_live === '1'){
						this.setState({stripe_live_checked: true,stripe_sandbox_checked:false });
					}else{
						this.setState({stripe_sandbox_checked: true,stripe_live_checked:false});
					}
	
					// if(formpayload.st_plugin_position === 'fixed'){
					// 	this.setState({st_position_checked: true });
					// }else{
					// 	this.setState({st_position_checked: false});
					// }

					if(formpayload.st_plugin_outerspace === 'mobilespaceadded'){
						this.setState({st_outer_space_checked: true });
					}else{
						this.setState({st_outer_space_checked: false});
					}
	
					if(formpayload.product_layout === '2'){
						this.setState({product_layout2_checked: true });
						this.setState({product_layout3_checked: false});
					}else{
						this.setState({product_layout3_checked: true});
						this.setState({product_layout2_checked: false });
					}
	
					if(formpayload.show_category_icons === 'yes'){
						this.setState({category_icons_yes: true });
						this.setState({category_icons_no: false});
					}else{
						this.setState({category_icons_no: true});
						this.setState({category_icons_yes: false });
					}

					if(formpayload.ai_json_update === 'yes'){
						this.setState({json_update_yes: true });
						this.setState({json_update_no: false});
					}else{
						this.setState({json_update_no: true});
						this.setState({json_update_yes: false });
					}


	  

					// if(formpayload.is_maintab_enable === 'yes'){
					// 	this.setState({maintab_enable_yes: true });
					// 	this.setState({maintab_enable_no: false});
					// }else{
					// 	this.setState({maintab_enable_yes: false});
					// 	this.setState({maintab_enable_no: true });
					// }
	
					if(res.data.font!== '' && res.data.font!== null){
						this.setselectedvalue(res.data.font);
					}
					if(res.data.fontvarientlist!== '' && res.data.fontvarientlist!== null){
						this.setselectedvariants(res.data.fontvarientlist);
					}
				}
			});

		var admin_id = localStorage.getItem('admin_id');
		axios.get(apiUrl+'font/getfont_name?admin_id='+admin_id)
			
			.then(res => {
				if(res.data.status == 'success'){
				
					this.setState({
						fonttype: res.data.fontlist
					})
				
				}else{
				//console.log("test")
				}
			});

		axios.get(apiUrl+'thememanagement/gettheme_name?admin_id='+admin_id).then(res => {
			if(res.data.status == 'success'){
			this.setState({
				themeData: res.data.themelist
			})
			}else{
			//console.log("test")
			}
		});
		this.myCallback();
		this.handleInputChange  = this.handleInputChange.bind(this);
		
	}

	confirmPopup = (key) =>{
		console.log(key,'this is fo rkey')
		this.setState({
			 activeShadowType: key
		});
		$('.input-popup-action').addClass('show');
	}
 onEditorAIChange = (event) => {
		this.setState({ description: event.editor.getData() });
	};
	handleInputChange(event) {

	  const {name, value} = event.target;      
	  this.setState({
		  [name]: value
		});
	  if(name === 'settings_mail_from_smtp'){
		 this.setState({smtp_checked: !this.state.smtp_checked});
	  }	
	  if(name === 'settings_enable_live'){
		 this.setState({stripe_live_checked: !this.state.stripe_live_checked});
		  this.setState({stripe_sandbox_checked: !this.state.stripe_sandbox_checked});
	  }	
	  if(name === 'settings_enable_sandbox'){
		 this.setState({stripe_sandbox_checked: !this.state.stripe_sandbox_checked});
		 this.setState({stripe_live_checked: !this.state.stripe_live_checked});
	  }	
	  if(name === 'product_layout'){
		 this.setState({product_layout2_checked: !this.state.product_layout2_checked});
		 this.setState({product_layout3_checked: !this.state.product_layout3_checked});
	  }

	  if(name === 'category_icons'){
		this.setState({category_icons_yes: !this.state.category_icons_yes});
		this.setState({category_icons_no: !this.state.category_icons_no});
	 }
	  if(name === 'json_update'){
		this.setState({json_update_yes: !this.state.json_update_yes});
		this.setState({json_update_no: !this.state.json_update_no});
	 }

	 
	//  if(name === 'enable_maintab'){
	// 	this.setState({maintab_enable_yes: !this.state.maintab_enable_yes});
	// 	this.setState({maintab_enable_no: !this.state.maintab_enable_no});
	//  }


	//   if(name === 'st_position'){
	//   	this.setState({st_position_checked: !this.state.st_position_checked});
	//   }

	  if (name === 'st_outer_space') {
		this.setState(prevState => ({
		  st_outer_space_checked: !prevState.st_outer_space_checked
		}));
	  }
	  
	   
	 if(name === 'show_shortcut'){
		this.setState({shortcut_icons_yes: !this.state.shortcut_icons_yes});
		this.setState({shortcut_icons_no: !this.state.shortcut_icons_no});
	 }

	}
	
	componentDidMount() {

		var admin_id =  localStorage.getItem("admin_id")
		axios.get(apiUrl+"adminpanel/getchatmodel?admin_id="+admin_id)
			.then(res => {			
				//console.log('faqmodeluserfaqmodeluserfaqmodeluser' , res.data)	
				if(res.data.status == 'success'){
					this.setState({
						faqmodelguest: res.data.faqmodelguest,
						faqmodeluser: res.data.faqmodeluser,
						faqmodelbroker: res.data.faqmodelbroker,
						faqmodellender: res.data.faqmodellender,
						faqmodelcompany: res.data.faqmodelcompany,
					all_models: res.data.all_models,

					});		
				}
			});

	  document.title = PageTitle('Settings');
	  if(localStorage.getItem('admin_id') === null){
	  this.props.history.push('/');
	  }
	  let body = document.querySelectorAll("body")[0];
	if(localStorage.getItem('admin_id')){
		body.classList.remove("body-theme");
	}else{
		body.classList.add("body-theme");
	}

	$('.num_valid').on('keypress', function(){
		var val = $(this).val();
		var length = val.length;
		var maxlength = $(this).attr("maxlength");
		
		if(length >= maxlength){
			return false;
		}
	})
	 }
	 


	handleFormSubmit = () => {
			if(this.validateForm()){
				this.setState({Loading:true});
				
				const config = {
					headers: {
					  'Content-Type': 'multipart/form-data'
					}
				  };
				  
				const formPayload = this.state;

				var qs = require('qs');
				if(this.state.smtp_checked === true){
					var settings_mail_from_smtp = '1';
				}else{
					 settings_mail_from_smtp = '0';
				}
				if(this.state.stripe_live_checked === true){
					var settings_enable_live = '1';
				}else{
					 settings_enable_live = '0';
				}

				// if(this.state.st_position_checked === true){
				// 	var plugin_position = 'fixed';
					
				// }else{
				// 	 var  plugin_position = 'absolute';
				// }

			
				
				var fonttype;
				if(formPayload.selectedFont[0]==undefined){
					fonttype = formPayload.selectedFont.value;
				}else{
					fonttype = formPayload.selectedFont[0].value;
				}

				if(this.state.st_outer_space_checked === true){
					var plugin_outerspace = 'mobilespaceadded';
					
				}else{
					var plugin_outerspace = 'mobilespaceremoved';
					 
				}
				var product_layout = '';
				if(this.state.product_layout3_checked === true){
					 product_layout = '3';
				}else{
					 product_layout = '2';
				}

				var show_category = '';
				if(this.state.category_icons_yes === true){
					show_category = 'yes';
				}else{
					show_category = 'no';
				}

				var show_shortcut = '';
				if(this.state.shortcut_icons_yes === true){
					show_shortcut = 'yes';
				}else{
					show_shortcut = 'no';
				}

				var json_update = '';
				if(this.state.json_update_yes === true){
					json_update = 'yes';
				}else{
					json_update = 'no';
				}

				var themeId;
				if(formPayload.selTheme[0]==undefined){
					themeId = formPayload.selTheme.value;
				}else{
					themeId = formPayload.selTheme[0].value;
				}

				// var maintab_enable_value = '';
				// if(this.state.maintab_enable_yes === true){
				// 	maintab_enable_value = 'yes';
				// }else{
				// 	maintab_enable_value = 'no';
				// }

				var postObject = {
					settings_id: formPayload.settings_id,
					settings_site_title:formPayload.settings_site_title,
					settings_from_name:formPayload.settings_from_name,
					settings_admin_email:formPayload.settings_admin_email,
					settings_from_email:formPayload.settings_from_email,
					notification_email: formPayload.notification_email,
					settings_mailpath:formPayload.settings_mailpath,
					settings_company_address:formPayload.settings_company_address,
					settings_commission_percentage:formPayload.settings_commission_percentage,
					site_background: formPayload.hexColor,
					smtp_host:formPayload.settings_smtp_host,
					smtp_user:formPayload.settings_smtp_user,
					smtp_pass:formPayload.settings_smtp_pass,
					smtp_port:formPayload.settings_smtp_port,
					admin_user:formPayload.settings_username,
					admin_no:formPayload.settings_mobileno,
					settings_email_footer:formPayload.settings_email_footer,
					settings_mail_from_smtp:settings_mail_from_smtp,
					settings_public_key:formPayload.settings_public_key,
					settings_product_key:formPayload.settings_product_key,
					setting_goal_amount:formPayload.setting_goal_amount,
					supporter_additional_fee:formPayload.supporter_additional_fee,
					settings_secret_key:formPayload.settings_secret_key,
					primary_font:formPayload.primary_font,
					main_tab_font_size:formPayload.main_tab_font_size,
					menu_font_size:formPayload.menu_font_size,
					settings_enable_live:settings_enable_live,
					st_position: formPayload.st_position,
					st_position_top:(formPayload.st_position_top!='')?formPayload.st_position_top:'',
					st_position_bottom:(formPayload.st_position_bottom!='')?formPayload.st_position_bottom:'',
					st_position_left:(formPayload.st_position_left!='')?formPayload.st_position_left:'',
					st_position_right:(formPayload.st_position_right!='')?formPayload.st_position_right:'',
					//st_plugin_radius:formPayload.st_plugin_radius,
					st_plugin_height:(formPayload.st_plugin_height!='')?formPayload.st_plugin_height:0,
					//st_dropdown_menu_radius:formPayload.st_dropdown_menu_radius,
					//inputRadius:formPayload.inputRadius,
					//textareaRadius:formPayload.textareaRadius,
					
					
					
				//	font 		  : fonttype,
					settings_commision_amount: formPayload.settings_commision_amount,
					merchant_commision_to_broker: formPayload.merchant_commision_to_broker,		
					lender_purchase_count: formPayload.lender_purchase_count,								
					
					google_analystic_code: formPayload.google_analystic_code,
					product_layout: product_layout,
					removeId: formPayload.removeID,
					show_category_icons: show_category,
					//is_maintab_enable: maintab_enable_value,
					landing_page:formPayload.landing_page,
					header_cat_limit: formPayload.header_cat_limit,
					guestuserfileupload: formPayload.guestuserfileupload,
					userfileupload: formPayload.userfileupload,
					book_keepingfileupload: formPayload.book_keepingfileupload,
					factor_rate: formPayload.st_factor_rate,
					invite_friends_perc: formPayload.invite_friends_perc,
					np_theme: formPayload.np_theme,
					count_domain: formPayload.count_domain,
					settings_faq_common_model_id:formPayload.selectedfaqmodelcommonval,
					settings_faq_user_model_id:formPayload.selectedfaqmodeluserval,
					settings_faq_guest_model_id:formPayload.selectedfaqmodelguestval,
					settings_faq_lender_model_id:formPayload.selectedfaqmodellenderval,
					settings_faq_company_model_id:formPayload.selectedfaqmodelcompanyval,
					aichat_type:formPayload.aichat_type,
					ai_fine_tune_model_id: formPayload.ai_fine_tune_model_id,
					leads_tax: formPayload.leads_tax,
					leads_purchase_amount: formPayload.leads_purchase_amount,
					lender_invite_desc: formPayload.lender_invite_desc,
					investor_invite_desc: formPayload.investor_invite_desc,
					old_lender_invite_img: formPayload.old_lender_invite_img,
					old_investor_invite_img: formPayload.old_investor_invite_img,
					old_email_header_img: formPayload.old_email_header_img,
					pluginwidth: formPayload.pluginwidth_value,
					chatmodulevalue: formPayload.chatmodulevalue,
					
					chat_api_key : formPayload.chat_api_key ,
					terms_and_condition:(localStorage.getItem('terms_and_condition'))?localStorage.getItem('terms_and_condition') : formPayload.terms_and_condition ,
					st_varient_id:formPayload.st_varient_id,

					main_tab_font_size:formPayload.main_tab_font_size,
					menu_font_size:formPayload.menu_font_size,
					primary_font:formPayload.primary_font,
					lineHeight:formPayload.lineHeight,
					//fontDetails:JSON.stringify(formPayload.fontDetails),
					show_shortcut: show_shortcut,
					plugin_outerspace: plugin_outerspace,
					shadow: JSON.stringify(this.state.shadows),
					json_update:json_update,
					st_aisidebar_icon_width:formPayload.st_aisidebar_icon_width,
					st_aisidebar_main_width:formPayload.st_aisidebar_main_width,
					st_aisidebar_collapsed_width:formPayload.st_aisidebar_collapsed_width,
					st_inner_position_left:formPayload.st_inner_position_left,
					st_inner_position_bottom:formPayload.st_inner_position_bottom,
					st_inner_position_right:formPayload.st_inner_position_right,
					st_inner_position_top:formPayload.st_inner_position_right,
					st_scalar_height:formPayload.st_scalar_height,
					st_scalar_width:formPayload.st_scalar_width,
					old_scalar_img:formPayload.old_scalar_img,
					themeId:themeId,
					dashboardview: formPayload.dashboard_view,
					leadsView: formPayload.lead_view,
				    terms_services: this.state.terms_services,
					capital_provider: this.state.capital_provider,
					privacy_policy: this.state.privacy_policy,
					borrower_terms: this.state.borrower_terms,
					crypto_terms: this.state.crypto_terms,
					disclosure_policy_terms: this.state.disclosure_policy_terms
				};
				console.log(postObject,'postObject')
				let formData = new FormData();
				for(let k in postObject) {
				formData.append(k, postObject[k]);
				}
			/* 	var domains = formPayload.domainSets
				for(let i in domains){
					formData.append('domainName[]',domains[i]['domain_name'])
				} */
				
				var lender_icondata = formPayload.lender_icon;
				formData.append('lender_invite_file',lender_icondata)
				var investor_icondata = formPayload.investor_icon;
				formData.append('investor_invite_file',investor_icondata)

				var email_icondata = formPayload.email_icon;
				formData.append('email_header_image',email_icondata)
				var scalar_icondata = formPayload.scalar_icon;
				formData.append('scalar_icon_image',scalar_icondata)

				var domains = formPayload.domainSets;

				for(let i in domains){

					if(domains[i]['domain_id'] ==  'undefined'){
						formData.append('domainName['+ i + '][domain_id]','null')		
					}else if(domains[i]['domain_id'] !==  undefined && domains[i]['domain_id'] !==  ''){
						formData.append('domainName['+ i + '][domain_id]',domains[i]['domain_id'])
					}

					formData.append('domainName['+ i + '][domain_name]',domains[i]['domain_name'])
					formData.getAll('domainName');
				}

				axios.post(apiUrl+"adminpanel/settingsave",formData,config).then(res => {
	
					if(res.data.results){
						this.setState({Loading:false});
								const formpayload = res.data.results;
								$('.success_message').html('<div class="status_sucess"><h3>'+ res.data.message+'</h3></div>');
								this.setState({settings_id:formpayload.settings_id});
								this.setState({terms_and_condition:formpayload.terms_and_condition});
								this.setState({settings_site_title:formpayload.settings_site_title});
								this.setState({settings_from_name:formpayload.settings_from_name});
								this.setState({settings_admin_email:formpayload.settings_admin_email});
								this.setState({notification_email:formpayload.notification_email}); 
								this.setState({settings_from_email:formpayload.settings_from_email});
								this.setState({settings_mailpath:formpayload.settings_mailpath});
								this.setState({settings_company_address:formpayload.settings_company_address});
								this.setState({settings_commission_percentage:formpayload.settings_commission_percentage});
								this.setState({settings_smtp_host:formpayload.settings_smtp_host});
								this.setState({settings_smtp_user:formpayload.settings_smtp_user});
								this.setState({settings_smtp_pass:formpayload.settings_smtp_pass});
								this.setState({settings_smtp_port:formpayload.settings_smtp_port});
								this.setState({settings_username:formpayload.settings_username});
								this.setState({settings_mobileno:formpayload.settings_mobileno});
								this.setState({settings_email_footer:formpayload.settings_email_footer});
								this.setState({hexColor:formpayload.settings_site_background_color});
								this.setState({settings_public_key:formpayload.settings_public_key});
								this.setState({settings_product_key:formpayload.settings_product_key});
								this.setState({setting_goal_amount:formpayload.setting_goal_amount});
								this.setState({supporter_additional_fee:formpayload.supporter_additional_fee});
								this.setState({settings_secret_key:formpayload.settings_secret_key});
								this.setState({primary_font:formpayload.primary_font});
								this.setState({main_tab_font_size:formpayload.main_tab_font_size});
								this.setState({menu_font_size:formpayload.menu_font_size});
								this.setState({lineHeight:formpayload.lineHeight});
								this.setState({settings_embedcode:formpayload.settings_embedcode});
								this.setState({settings_access_code:formpayload.access_code});
								// this.setState({count_domain:formpayload.count_domain});				
								this.setState({st_position_left:formpayload.st_position_left});
								this.setState({st_position_right:formpayload.st_position_right});

								this.setState({ terms_services: formpayload.terms_services });
								this.setState({ capital_provider: formpayload.capital_provider });
								this.setState({ privacy_policy: formpayload.privacy_policy });
								this.setState({ borrower_terms: formpayload.borrower_terms });
								this.setState({ crypto_terms: formpayload.crypto_terms });
								this.setState({ disclosure_policy_terms: formpayload.disclosure_policy_terms });
								
								this.setState({st_position_top:formpayload.st_position_top});
								//this.setState({st_plugin_radius:formpayload.st_plugin_radius});
								this.setState({st_plugin_height:formpayload.st_plugin_height});
								//this.setState({st_dropdown_menu_radius:formpayload.st_dropdown_menu_radius});
								//this.setState({inputRadius:formpayload.inputRadius});
								//this.setState({textareaRadius:formpayload.textareaRadius});
								
								this.setState({st_position_bottom:formpayload.st_position_bottom});
								this.setState({domainSets: formpayload.domainSets});
								this.setState({settings_commision_amount: formpayload.settings_commision_amount});
								this.setState({merchant_commision_to_broker: formpayload.merchant_commision_to_broker});	
								this.setState({lender_purchase_count: formpayload.lender_purchase_count});																
								this.setState({header_cat_limit: formpayload.header_cat_limit});
								this.setState({guestuserfileupload: formpayload.guestuserfileupload_limit});
								this.setState({userfileupload: formpayload.userfileupload_limit});	
								this.setState({book_keepingfileupload: formpayload.book_keepingfileupload_limit});
								this.setState({st_factor_rate: formpayload.factor_rate});
								
								this.setState({leads_tax: formpayload.leads_tax});
								this.setState({leads_purchase_amount: formpayload.leads_purchase_amount});
								this.setState({lender_invite_desc: formpayload.lender_invitation_desc});
								this.setState({investor_invite_desc: formpayload.investor_invitation_desc});
								this.setState({chat_api_key: formpayload.chat_api_key});
								this.setState({ dashboard_view: formpayload.dashboardview });
								this.setState({ lead_view: formpayload.leadsView });
								
								this.setState({landing_page:formpayload.landing_page});

								this.setState({st_position: formpayload.st_plugin_position},()=>{
									if(formpayload.st_plugin_position =='absolute'){
										$('.d-height').removeClass('d-none');
									}else{
										$('.d-height').addClass('d-none');
									}
								});

								if(formpayload.lender_invitation_template !== null){
									this.setState({old_lender_invite_img:formpayload.lender_invitation_template});
								}
								if(formpayload.investor_invitation_template !== null){
									this.setState({old_investor_invite_img:formpayload.investor_invitation_template});
								}

								if(formpayload.email_header_image !== null){
									this.setState({old_email_header_img:formpayload.email_header_image});
								}
								if(formpayload.scalar_icon_image !== null){
									this.setState({old_scalar_icon_img:formpayload.scalar_icon_image});
								}
								if(formpayload.settings_faq_common_model_id!== 'null' && formpayload.settings_faq_common_model_id !== ''){
									this.setState({selectedfaqmodelcommon: {value:formpayload.settings_faq_common_model_id, label:formpayload.settings_faq_common_model_id},selectedfaqmodelcommonval:formpayload.settings_faq_common_model_id });
								}
								
								if(formpayload.settings_faq_user_model_id!== 'null' && formpayload.settings_faq_user_model_id !== ''){
									this.setState({selectedfaqmodeluser: {value:formpayload.settings_faq_user_model_id, label:formpayload.settings_faq_user_model_id},selectedfaqmodeluserval:formpayload.settings_faq_user_model_id });
								}
								if(formpayload.settings_faq_guest_model_id!== 'null' && formpayload.settings_faq_guest_model_id !== ''){
									this.setState({selectedfaqmodelguest: {value:formpayload.settings_faq_guest_model_id, label:formpayload.settings_faq_guest_model_id},selectedfaqmodelguestval:formpayload.settings_faq_guest_model_id});
								}
								if(formpayload.settings_faq_doctor_model_id!== 'null' && formpayload.settings_faq_doctor_model_id !== ''){
									this.setState({selectedfaqmodelbroker: {value:formpayload.settings_faq_doctor_model_id, label:formpayload.settings_faq_doctor_model_id},selectedfaqmodelbrokerval:formpayload.settings_faq_doctor_model_id});
								}
								if(formpayload.settings_faq_company_model_id!== 'null' && formpayload.settings_faq_company_model_id !== ''){
									this.setState({selectedfaqmodelcompany: {value:formpayload.settings_faq_company_model_id, label:formpayload.settings_faq_company_model_id},selectedfaqmodelcompanyval:formpayload.settings_faq_company_model_id });
								}
								if(formpayload.settings_faq_technician_model_id!== 'null' && formpayload.settings_faq_technician_model_id !== ''){
									this.setState({selectedfaqmodellender: {value:formpayload.settings_faq_technician_model_id, label:formpayload.settings_faq_technician_model_id},selectedfaqmodellenderval:formpayload.settings_faq_technician_model_id });
								}
								this.setState({aichat_type: formpayload.ai_model_type});
								this.setState({ai_fine_tune_model_id: formpayload.ai_fine_tune_model_id});

								if( formpayload.google_analystic_code !== 'null'){
									this.setState({google_analystic_code: formpayload.google_analystic_code});
								}else{
									this.setState({google_analystic_code: ''});
								}

								if(formpayload.settings_mail_from_smtp === '1'){
									this.setState({smtp_checked: true});
								}else{
									this.setState({smtp_checked: false});
								}


								// if(formpayload.st_plugin_position === 'fixed'){
								// 	this.setState({st_position_checked: true });
								// }else{
								// 	this.setState({st_position_checked: false});
								// }

								if(formpayload.product_layout === '2'){
									this.setState({product_layout2_checked: true });
									this.setState({product_layout3_checked: false});
								}else{
									this.setState({product_layout3_checked: true});
									this.setState({product_layout2_checked: false });
								}

								if(formpayload.enable_live === '1'){
									this.setState({stripe_checked: true});
								}else{
									this.setState({stripe_checked: false});
								}

								if(formpayload.show_category_icons === 'yes'){
									this.setState({category_icons_yes: true });
									this.setState({category_icons_no: false});
								}else{
									this.setState({category_icons_no: true});
									this.setState({category_icons_yes: false });
								}

								// if(formpayload.is_maintab_enable === 'yes'){
								// 	this.setState({maintab_enable_yes: true });
								// 	this.setState({maintab_enable_no: false});
								// }else{
								// 	this.setState({maintab_enable_yes: false});
								// 	this.setState({maintab_enable_no: true });
								// }


								if(formpayload.pluginwidth === '600'){
									
									this.setState({selectedOption:{value: '600', label: '600px'}});
								}else{
									
									this.setState({selectedOption:{value: '630', label: '630px'}});
					
								}
								scrollToTop();

								setTimeout(
									function() {
										$('.success_message').html('');
									}
									.bind(this),
									3000
									);
					}
						 
				 }); 
			}
	}

	validateForm() {

		const {settings_commision_amount,merchant_commision_to_broker,lender_purchase_count,settings_id,settings_site_title,settings_from_name,settings_admin_email,settings_from_email,settings_company_address,settings_commission_percentage,settings_smtp_host,settings_smtp_user,settings_smtp_pass,settings_smtp_port,settings_username,settings_mobileno,settings_email_footer,settings_public_key,settings_product_key,setting_goal_amount,supporter_additional_fee,settings_secret_key,settings_embedcode,selectedFont,invite_friends_perc,domainSets,module_type,admin_id,leads_tax,leads_purchase_amount, primary_font, main_tab_font_size, menu_font_size, st_position, st_position_bottom, st_position_top, st_position_right, st_position_left,selTheme} = this.state;
		let errors = 0;
		//let formIsValid = true;
		  
		  if (!domainSets.length>0) { 
			
			errors++;
			$('.errorsettings_domain').html('<span class="errorspan">Please add atleast one domain</span>');
		}else{		
			$('.errorsettings_domain').html('');
		}
		if (!settings_site_title) { 

			errors++;
			$('.errorsettings_site_title').html('<span class="errorspan">Please fill the field</span>');
		}else if(settings_site_title){		
			$('.errorsettings_site_title').html('');
		}
		
		if (!settings_from_name) { 
			errors++;
			$('.errorsettings_from_name').html('<span class="errorspan">Please fill the field</span>');
		}else if(settings_from_name){
			$('.errorsettings_from_name').html('');
		}

		if (!settings_admin_email) {
			errors++; 
			$('.errorsettings_admin_email').html('<span class="errorspan">Please fill the field</span>');
		}else if(settings_admin_email){
			$('.errorsettings_admin_email').html('');
		}
		if (!settings_from_email) {
			errors++; 
			$('.errorsettings_from_email').html('<span class="errorspan">Please fill the field</span>');
		}else if(settings_from_email){
			$('.errorsettings_from_email').html('');
		}
		

		if (!settings_mobileno) { 
			errors++;
			$('.errorsettings_mobileno').html('<span class="errorspan">Please fill the field</span>');
		}else if(settings_mobileno){
			$('.errorsettings_mobileno').html('');
		} 


		if (!leads_tax) { 
			errors++;
			$('.errorleads_tax').html('<span class="errorspan">Please fill the field</span>');
		}else if(leads_tax){
			$('.errorleads_tax').html('');
	
			if (leads_tax < 1 || leads_tax > 100) {
				errors++;
	//console.log(leads_tax,"leads_taxleads_taxleads_tax")
				$('.errorleads_tax').html('<span class="errorspan">Percentage must be greater than or equal to 1 and less than or equal to 100</span>');
				// $('.errorleads_tax').html('<span class="errorspan">percentage must be greater than 1 and less than or equal to 100</span>');
	
			}else if(/^[0-9]*\.?[0-9]*$/.test(leads_tax)){
				$('.errorleads_tax').html('');
			  }else{
				errors++;
			$('.errorleads_tax').html('<span class="errorspan">Please enter the valid tax</span>');
			  }
			}
	
		


		
		if (!leads_purchase_amount) { 
			errors++;
			$('.errorleads_purchase_amount').html('<span class="errorspan">Please fill the field</span>');
		}else if(leads_purchase_amount){
			$('.errorleads_purchase_amount').html('');
	
			if (leads_purchase_amount.length  > 6) {
				errors++;
				$('.errorleads_purchase_amount').html('<span class="errorspan">Purchase amount must be 10 digits </span>');
				// $('.errorleads_tax').html('<span class="errorspan">percentage must be greater than 1 and less than or equal to 100</span>');
	
			}else if(/^[0-9]*\.?[0-9]*$/.test(leads_purchase_amount)){
				$('.errorleads_purchase_amount').html('');
			  }else{
				errors++;
			$('.errorleads_purchase_amount').html('<span class="errorspan">Please enter the valid amount</span>');
			  }
			}
	

		if(admin_id == 1 && module_type ==='withlenders'){
			
			if (!merchant_commision_to_broker) { 
				errors++;
				$('.errormerchant_commision_to_broker').html('<span class="errorspan">Please fill the field</span>');
			}else if(merchant_commision_to_broker){
				$('.errormerchant_commision_to_broker').html('');
			}

			if (!lender_purchase_count) { 
				errors++;
				$('.errorlender_purchase_count').html('<span class="errorspan">Please fill the field</span>');
			}else if(lender_purchase_count){
				$('.errorlender_purchase_count').html('');
			}
			}
			if (!settings_email_footer) { 
				errors++;
				$('.errorsettings_email_footer').html('<span class="errorspan">Please fill the field</span>');
			}else if(settings_email_footer){
				$('.errorsettings_email_footer').html('');
			}

			
			if(admin_id == 1 && module_type ==='withlenders'){
			if (!settings_public_key) {
				errors++;
				$('.errorsettings_public_key').html('<span class="errorspan">Please fill the field</span>');
			}else if(settings_public_key){
				$('.errorsettings_public_key').html('');
			}

			if (!settings_product_key) {
				errors++;
				$('.errorsettings_product_key').html('<span class="errorspan">Please fill the field</span>');
			}else if(settings_product_key){
				$('.errorsettings_product_key').html('');
			}
			
			if (!settings_secret_key) {
				errors++;
				$('.errorsettings_secret_key').html('<span class="errorspan">Please fill the field</span>');
			}else if(settings_secret_key){
				$('.errorsettings_secret_key').html('');
			}
			if (!primary_font) {
				errors++;
				$('.errorprimary_font').html('<span class="errorspan">Please fill the field</span>');
			}else if(primary_font){
				$('.errorprimary_font').html('');
			}
			if (!main_tab_font_size) {
				errors++;
				$('.errormain_tab_font_size').html('<span class="errorspan">Please fill the field</span>');
			}else if(main_tab_font_size){
				$('.errormain_tab_font_size').html('');
			}
			if (!menu_font_size) {
				errors++;
				$('.errormenu_font_size').html('<span class="errorspan">Please fill the field</span>');
			}else if(menu_font_size){
				$('.errormenu_font_size').html('');
			}
		
			if (!invite_friends_perc) {
				errors++;
				$('.errorinvite_friends_perc').html('<span class="errorspan">Please fill the field</span>');
			}else if(invite_friends_perc){
				//console.log(invite_friends_perc)
				if(invite_friends_perc == 0){
					errors++;
					$('.errorinvite_friends_perc').html('<span class="errorspan"> Please give atleast 1%</span>');
				}else{
					$('.errorinvite_friends_perc').html('');
				}
				
			}
		}
		if (st_position == 'fixed') {			
			if (!st_position_top) {
				errors++;
				$('.errorsettings_st_position_top').html('<span class="errorspan">Please fill the field</span>');
			}else if(st_position_top){
				$('.errorsettings_st_position_top').html('');
			}	
			if (!st_position_bottom) {
				errors++;
				$('.errorsettings_st_position_bottom').html('<span class="errorspan">Please fill the field</span>');
			}else if(st_position_bottom){
				$('.errorsettings_st_position_bottom').html('');
			}	
			if (!st_position_left && !st_position_right) {
				errors++;
				$('.errorsettings_st_position_left').html('<span class="errorspan">Please enter either the left or right field.</span>');
			}else if (st_position_left && st_position_right) {
				errors++;
				$('.errorsettings_st_position_left').html('<span class="errorspan">Please enter either the left or right field.</span>');
			}else{
				$('.errorsettings_st_position_left').html('');
			}	
		} 
		else if (st_position == 'absolute') {			
			
			if (!st_position_top && !st_position_bottom) {
				errors++;
				$('.errorsettings_st_position_top').html('<span class="errorspan">Please enter either the top or bottom field.</span>');
			}else if (st_position_top && st_position_bottom) {
				errors++;
				$('.errorsettings_st_position_top').html('<span class="errorspan">Please enter either the top or bottom field.</span>');
			}else{
				$('.errorsettings_st_position_top').html('');
			}	

			if (!st_position_left && !st_position_right) {
				errors++;
				$('.errorsettings_st_position_left').html('<span class="errorspan">Please enter either the left or right field.</span>');
			}else if (st_position_left && st_position_right) {
				errors++;
				$('.errorsettings_st_position_left').html('<span class="errorspan">Please enter either the left or right field.</span>');
			}else {
				$('.errorsettings_st_position_left').html('');
			}	
		} 
		
	  if(!selTheme || selTheme.length == 0){
		errors++;
		$('.errortheme').html('<span class="errorspan">Please select the theme.</span>');
	}else{
		if(selTheme.value == 0 || selTheme.value == ''){
			errors++;
			$('.errortheme').html('<span class="errorspan">Please select the theme.</span>');
		} else{
			$('.errortheme').html('');
		}
	}
		if(errors>0) {
		setTimeout(function () {
		scrollToTopValidate();
		}, 100);
		return false;
		}
		else {
		return true;
		}
	}

	componentWillReceiveProps(Props){

   

  

	}

	setselectedtheme(sel) {	
		this.setState({ selTheme: { value: sel.value, label: sel.label }, theme_id : sel.value });
	}

	setselectedvalue(selectsers){
		
		const fontArray = selectsers.map((fonttype, index) => ({
		 id: index,
		 name: fonttype,
		}));
	// Dynamically create select list
	let fonts = [];
	fontArray.map(item =>
	fonts.push({ label: item.name.label, value: item.name.value }),
	);
	this.setState({selectedFont : fonts})
  }
	setselectedvariants(selectvarients=null){
		
		selectvarients = (selectvarients != null ? selectvarients : {});
		if (Object.keys(selectvarients).length > 0) {	
		var listings = selectvarients.map((item, index) => {
				//fonts.push({ variant_id: item.name.id, variant_name: item.name.varient_name }),
				//console.log(item.id, '--isChecked')
				if(item.isChecked == 'checked'){
					this.state.st_varient_id.push(item.id);
				}
				//this.setState({ st_varient_id: [...this.state.st_varient_id, item.id] });
				return (						
					<div className="form-group" key={index}>
						<input 
						className='ms-0'
						onChange={this.handleCheckBoxChange.bind(this)}
						type="checkbox"  name="st_varients" 
						value={item.id}
						defaultChecked={item.isChecked}
						/>
						<span>{item.varient_name+' '+item.variant_weight}</span>
					</div>									
				);				
			});
		} else{
			var listings = '';
			this.setState({st_varient_id : []})
		}
		this.setState({selectedFontVariant : listings})
	}

	handleCheckBoxChange = (e) => {
		const isChecked = e.target.checked;
		const isCheckedVal = e.target.value;
		
		if(isChecked){
			this.setState({ st_varient_id: [...this.state.st_varient_id, e.target.value] });
		} else{
			// setSelectedId(selectedIds.filter(id=>id !== checkedId))
			// const index = this.state.st_varient_id.indexOf(e.target.value);
			// this.state.st_varient_id.splice(index,1);
			this.setState({ st_varient_id: this.state.st_varient_id.filter(id=>id !== e.target.value) });
		}
	};

	handleClick = () => {
	this.setState({ displayColorPicker: !this.state.displayColorPicker })
	};

	handleClose = () => {
	this.setState({ displayColorPicker: false })
	};

	handleChange = (color) => {
	this.setState({hexColor : color.hex})
	this.setState({ color: color.rgb })
	};

	 copyCodeToClipboard(event){
		event.preventDefault;
		const el = this.textArea
		el.select()
		document.execCommand("copy")
   }


   writeText = () => {
	 
	$('.copied_title').html('<span class=""><h3>Copied</h3></span>');

	//onClick={() =>  navigator.clipboard.writeText(tester)}
	let test1 = this.state.settings_access_code;
	
	let  tester =	'<script src="https://admin-f.uxt.design/plugin.js"></script> <div data-client="'+test1+'"  id="formbooking_container"></div>';
	 navigator.clipboard.writeText(tester);
	setTimeout(
		function() {
			$('.copied_title').html('');
			$('.copied_title').hide();
		}
		.bind(this),
		3000
		);
		
	}

	writeStandaloneText = () => {
	 
	$('.copied_title').html('<span class=""><h3>Copied</h3></span>');
	let test1 = this.state.settings_access_code;

	console.log(test1, "writeStandaloneText")
	
	let  standAlone =	'<script src="https://admin-f.uxt.design/plugin.js"></script> <div data-client="'+test1+'"  id="formbooking_container"></div>';
	 navigator.clipboard.writeText(standAlone);
	setTimeout(
		function() {
			$('.copied_title').html('');
			$('.copied_title').hide();
		}
		.bind(this),
		3000
		);
		
	}

/*    myCallback = (domainsets) => {
	//console.log(domainsets,'domainsets')
	this.setState({domainSets: domainsets});
  }; */

  myCallback = (domainsets,domainID) => {

	this.setState({domainSets: domainsets,removeID: domainID});
   };

   handleChangeChatModule = selectedChatmodule => {
		this.setState({ selectedChatmodule});
		this.setState({ chatmodulevalue : selectedChatmodule.value });
	}
   handleChangeFont = selectedFont => {
	  this.setState({ selectedFont});
	  this.setState({ fontvalue : selectedFont.value });
	  if(selectedFont.value === ''){
		//$('.errorfont').html('<span class="errorspan">Please select the font</span>');
	  }else{
		axios.get(apiUrl+'adminpanel/getfont_varient?font_id='+selectedFont.value)
			.then(res => {
				if(res.data.status == 'success'){					
					//if(res.data.fontvarientlist!== '' && res.data.fontvarientlist!== null){
						this.setselectedvariants(res.data.fontvarientlist);
					//}
				
				}else{
				//console.log("test")
					this.setselectedvariants(res.data.fontvarientlist);
				}
			});
		 $('.errorfont').html('');
	  }
   }

   
	isNumber(e) {
		var code = (e.which) ? e.which : e.keyCode;
		if (code > 31 && (code < 48 || code > 57)) {
			e.preventDefault();
		}
	}

	handleChangeAimodelcommon = selectedfaqmodelcommon => {
		this.setState({ selectedfaqmodelcommon});
		this.setState({ selectedfaqmodelcommonval : selectedfaqmodelcommon.value });	
		}

   handleChangeAimodeluser = selectedfaqmodeluser => {
	this.setState({ selectedfaqmodeluser});
	this.setState({ selectedfaqmodeluserval : selectedfaqmodeluser.value });	
	}
	handleChangeAimodelguest = selectedfaqmodelguest => {
		this.setState({ selectedfaqmodelguest});
		this.setState({ selectedfaqmodelguestval : selectedfaqmodelguest.value });	
	}
	handleChangeAimodelbroker = selectedfaqmodelbroker => {
		this.setState({ selectedfaqmodelbroker});
		this.setState({ selectedfaqmodelbrokerval : selectedfaqmodelbroker.value });	
	}

	handleChangeAimodelcompany = selectedfaqmodelcompany => {
		this.setState({ selectedfaqmodelcompany});
		this.setState({ selectedfaqmodelcompanyval : selectedfaqmodelcompany.value });	
	}
	handleChangeAimodellender = selectedfaqmodellender => {
		this.setState({ selectedfaqmodellender});
		this.setState({ selectedfaqmodellenderval : selectedfaqmodellender.value });	
	}
	handleChangeWidth = selectedOption => {
		this.setState({  selectedOption : selectedOption});
		this.setState({  pluginwidth_value : selectedOption.value});
	};
	onEditorChange( evt ) {
		// console.log(evt.editor.getData())
		// var callfunc = this;
		// setTimeout(function () {
		// callfunc.setState( {
		//     terms_and_condition: evt.editor.getData()
		// } );
		// }, 1000);
		localStorage.setItem('terms_and_condition',evt.editor.getData())
	 
	}

	onEditorTermsChange = (fieldName, event) => {
		if (!event?.editor) return;

		this.setState({
			[fieldName]: event.editor.getData()
		});
	};


	
	onChangeHandler=(action, event)=>{
		//console.log(action,"Setting.js");
		if(action == 'lender'){
			let reader = new FileReader();
			const file = event.target.files[0];
			const extension = file.name.split('.').pop();
			reader.onloadend = () => {
			  this.setState({
				lender_icon_name: file.name,
				lender_icon_preview: reader.result,
				lender_icon: file,
				lender_icon_fileExtension:extension,
				
			  });
			};
			reader.readAsDataURL(file);
		} else if(action == 'investor'){
			let reader = new FileReader();
			const file = event.target.files[0];
			const extension = file.name.split('.').pop();
			reader.onloadend = () => {
			  this.setState({
				investor_icon_name: file.name,
				investor_icon_preview: reader.result,
				investor_icon: file,
				investor_icon_fileExtension:extension,
				
			  });
			};
			reader.readAsDataURL(file);
		} else if(action == 'email_header_image'){
			let reader = new FileReader();
			const file = event.target.files[0];
			const extension = file.name.split('.').pop();
			reader.onloadend = () => {
			  this.setState({
				email_icon_name: file.name,
				email_icon_preview: reader.result,
				email_icon: file,
				email_icon_fileExtension:extension,
				
			  });
			};
			reader.readAsDataURL(file);
		} else if(action == 'scalar_icon'){
			let reader = new FileReader();
			const file = event.target.files[0];
			const extension = file.name.split('.').pop();
			reader.onloadend = () => {
			  this.setState({
				scalar_icon_name: file.name,
				scalar_icon_preview: reader.result,
				scalar_icon: file,
				scalar_icon_fileExtension:extension,
				
			  });
			};
			reader.readAsDataURL(file);
		}
	}

	  handleSave = () => {
			this.setState({Loading:true});
			const config = {
				headers: {
				  'Content-Type': 'multipart/form-data'
				}
			  };
			const formPayload = this.state;
			var qs = require('qs');
			var postObject = {
				
				settings_id: formPayload.settings_id,
				admin_id: localStorage.getItem('admin_id'),
				aifeed:this.state.description,
				type : formPayload.type,
				imp_cate : 6
				
			};

			let formData = new FormData();
			for(let k in postObject) {
			formData.append(k, postObject[k]);
			}
		
			
			

			axios.post(apiUrl+"faq/settingaifeedsave",formData,config).then(res => {
				if(res.data.results){
					// this.setState({Loading:false});
					// 		const formpayload = res.data.results;
					// 		$('.success_message').html('<div class="status_sucess"><h3>'+ res.data.message+'</h3></div>');
					// 		this.setState({settings_id:formpayload.settings_id});
					// 		scrollToTop();
					// 		setTimeout(
					// 			function() {
					// 				$('.success_message').html('');
					// 			}
					// 			.bind(this),
					// 			3000
					// 			);
				}
					 
			 }); 
		
	}
	addMoreFunc_old = (e) => {	
		return this.state.fontDetails.map((val, idx) => {
			
			let fontType = `fontType${idx}`,
			fontWeight = `fontWeight${idx}`,
			fontSize = `fontSize${idx}`,
			letterSpacing = `letterSpacing${idx}`,
			lineHeight = `lineHeight${idx}`,
			topSpace = `topSpace${idx}`,
			bottomSpace = `bottomSpace${idx}`,
			errorfile = `errorfile${idx}`;
			return ( <>
			  <div className="form-row mb-0" key={val.index}>
					  <div className='form-left'>			
					<div className="form-group"  >					
						<label className='pb-0'>
							{/* Apply font : */}
	
							{this.Capitalize(val.fontType)} :
							
							
							</label>	
						{/*  <div className='d-flex align-items-center gap-3'>					
						<select name="fontType" className="form-control" id={fontType} data-id={idx} onChange={(e) => this.handleFileChange(e, idx)}>
							<option value="" className="fontVarientName" > Select Type</option>
							<option value="PrimaryFont" className="fontVarientName" selected={val.fontType=='PrimaryFont'?true:false} > Primary Font</option>
							<option value="mainTab" className="fontVarientName" selected={val.fontType=='mainTab'?true:false} > MainTab</option>
							<option value="sideMenu" className="fontVarientName" selected={val.fontType=='sideMenu'?true:false} > SideMenu</option>
							<option value="title" className="fontVarientName" selected={val.fontType=='title'?true:false} > Title</option>
							<option value="subTitle" className="fontVarientName" selected={val.fontType=='subTitle'?true:false}> SubTitle</option>
							<option value="button" className="fontVarientName"selected={val.fontType=='button'?true:false} > Button</option>
							<option value="smButton" className="fontVarientName" selected={val.fontType=='smButton'?true:false}> SmallButton</option>
							<option value="lgButton" className="fontVarientName" selected={val.fontType=='lgButton'?true:false}> LargeButton</option>										
						</select>						
						{idx === 0 ? (
						<span className="add_font_varients cursor-pointer"  onClick={() => this.addFunc()}><i class="fa fa-plus-circle fa-1x"></i></span> ) : 
						<span className="btn_remove cursor-pointer" onClick={() => this.deleteFunc(val)} ><i class="fa fa-trash fa-1x"></i></span>
						}	
						</div>	 */}
						<div className='mt-2'>{val.fontTypeCheck}</div>				
					</div>
					</div>
				</div>
				<div className="form-row" key={val.index}>	
					{this.varientField(val.fontType,idx,val)}
				  </div>
			  </>
			);
		  });
	}
	varientField_old = (fontType,idx,val)=>{
		const fontArray = this.state.fonttype.map ((fonttype, index) => ({
			id: index,
			name: fonttype,
			}));
			// Dynamically create select list
			let fonts = [];
			fontArray.map(item =>
				fonts.push({ label: item.name.label, value: item.name.value }),
			);
	
		let fontWeight = `fontWeight${idx}`,
			fontSize = `fontSize${idx}`,
			letterSpacing = `letterSpacing${idx}`,
			lineHeight = `lineHeight${idx}`,
			topSpace = `topSpace${idx}`,
			bottomSpace = `bottomSpace${idx}`,
			errorfile = `errorfile${idx}`
			if(fontType !=='smButton' && fontType!=='lgButton'){
			return(
				<>
				<div className="form-left">
					<div className="form-group">
						<label>Font Family  :</label>
						<div>																
							{/* <Select 
								options={fonts}  
								value={FontFamily}
								//onChange={this.handleChangeFont}
								placeholder="Select Font Type" 
								name="FontFamily" 
								id={FontIndId} 
								data-id={idx} 								
								onChange={(e) => this.handleFileChange(e, idx)}
							/> */}

							<select name="font_id" className="form-control" id={fontType} data-id={idx} onChange={(e) => this.handleFileChange(e, idx)}>

							<option value="" className="fontFamilyId" > Select Font</option>						
							{fonts.map((option) => (
							<option key={option.value} value={option.value}  selected={val.font_id==option.value?true:false}>
								{option.label}
							</option>
							))}
							</select>	
							<div className={errorfile}></div> 						
						</div>
					</div>	
				</div>
				
				<div className="form-right">
					<div className="form-group">
						<label>Font Variant :</label>
						<div>
							<select name="fontWeight" className="form-control" id={fontType} data-id={idx} onChange={(e) => this.handleFileChange(e, idx)}>
	
							<option value="" className="fontVarientName" > Select Variant</option>
							<option value="200" className="fontVarientName" selected={val.fontWeight=='200'?true:false} > Extra Light200</option>
							<option value="300" className="fontVarientName" selected={val.fontWeight=='300'?true:false}> Light 300</option>
							<option value="400" className="fontVarientName" selected={val.fontWeight=='400'?true:false}> Regular 400</option>
							<option value="500" className="fontVarientName" selected={val.fontWeight=='500'?true:false}> Medium 500</option>
							<option value="600" className="fontVarientName" selected={val.fontWeight=='600'?true:false} > Semi Bold 600</option>
							<option value="700" className="fontVarientName" selected={val.fontWeight=='700'?true:false}> Bold 700</option>
							<option value="800" className="fontVarientName" selected={val.fontWeight=='800'?true:false}> Extra Bold 800</option>
							<option value="900" className="fontVarientName" selected={val.fontWeight=='900'?true:false}>Black 900</option>
											
							</select>	
	
	
										
							<div className={errorfile}></div> 
						</div>
					</div>	
				</div>	
				<div className="form-left">
					<div className="form-group">
						<label>Font Size  :</label>
						<div>
							<input type="text" name="fontSize" 
							onChange={(e) => this.handleFileChange(e, idx)} 
							//onChange={this.onFileChange}
							value={val.fontSize}
	
							data-id={idx}
							id={fontSize}    /> 
										
							<div className={errorfile}></div> 
						</div>
					</div>	
				</div>
				</>);
			}else if(fontType =='smButton' || fontType=='lgButton' || fontType=='pluginOpenButton'){
				return(<>
				<div className="form-left">
					<div className="form-group">
						<label>Top Space :</label>
						<div>
							<input type="text" name="topSpace" 
							onChange={(e) => this.handleFileChange(e, idx)} 
							value={val.topSpace}
							data-id={idx}
							id={topSpace}    /> 
										
							<div className={errorfile}></div> 
						</div>
					</div>	
				</div>
				<div className="form-right">
					<div className="form-group">
						<label>Bottom Space :</label>
						<div>
							<input type="text" name="bottomSpace" 
							onChange={(e) => this.handleFileChange(e, idx)} 
							value={val.bottomSpace}
							data-id={idx}
							id={bottomSpace}    /> 									
							<div className={errorfile}></div> 
						</div>
					</div>	
				</div>	
				</>);
			}
	
	}
	
	handleFileChange = async  (e, idx,fontLabel, fontValue) => {
		let	font_file = `font_file${idx}`;
		let fontDetails = [...this.state.fontDetails];
		
		
		fontDetails[e.target.dataset.id]['varient_id'] = idx;	
		fontDetails[e.target.dataset.id][e.target.name] = e.target.value;
			let selectedFont = e.target.name;
	
			
	
			
		if (fontValue) {
			try {
				const response = await axios.get(`${apiUrl}font/getvarientlistdetail`, {
					params: {
						id: fontValue,     
						name: fontLabel     
					}
				});
				if (response.data.variants) {
					fontDetails[idx] = { 
						...fontDetails[idx], 
						variants: response.data.variants  
					};
					console.log(response.data.variants,'this is fortvarientrecords')
				}
			} catch (error) {
				console.error("Error fetching font variants:", error);
			}
		}
	
		this.setState({ fontDetails }, () => {
			console.log(this.state.fontDetails, 'Updated fontDetails'); 
		});
	
	}; 
	// ================================font end ====================
	Capitalize(str){
		return str.charAt(0).toUpperCase() + str.slice(1);
	}

	addMoreFunc = (e) => {	
		return this.state.fontDetails.map((val, idx) => {
			
			let FontType = `FontType${idx}`,
			fontWeight = `fontWeight${idx}`,
			FontSize = `FontSize${idx}`,
			letterSpacing = `letterSpacing${idx}`,
			lineHeight = `lineHeight${idx}`,
			TopSpace = `TopSpace${idx}`,
			BottomSpace = `BottomSpace${idx}`,
			errorfile = `errorfile${idx}`;
			return ( <>
			  <div className="form-row mb-0" key={val.index}>
					  <div className='form-left'>			
					<div className="form-group"  >					
						<label className='pb-0'>
							{/* Apply font : */}
	
							Font Apply to {this.Capitalize(val.fontType)}
							
							</label>	
						
						<div className='mt-2'>{val.FontTypeCheck}</div>				
					</div>
					</div>
				</div>
				<div className="form-row" key={val.index}>	
					{this.varientField(val.fontId, val.fontFamily, val.fontType,idx,val,val.index)}
				  </div>
			  </>
			);
		  });
	}
	handleFileChangeVarients = async  (e, idx,fontLabel, fontValue) => {
		let	font_file = `font_file${idx}`;
		let fontDetails = [...this.state.fontDetails];
		
		fontDetails[idx] = {
			...fontDetails[idx],
			fontWeight: e.target.value 
		};
		fontDetails[e.target.dataset.id]['varient_id'] = idx;	
		fontDetails[e.target.dataset.id][e.target.name] = e.target.value;
			let selectedFont = e.target.name;
		this.setState({ fontDetails }, () => {
			console.log(this.state.fontDetails, 'Updated fontDetails'); 
		});
	
	};
	regularOption = (val) => {
		return (
		  <>
			<option 
			  value="200" 
			  className="fontVarientName" 
			  selected={val.fontWeight === '200'}
			>
			  Extra Light 200
			</option>
			<option 
			  value="300" 
			  className="fontVarientName" 
			  selected={val.fontWeight === '300'}
			>
			  Light 300
			</option>
			<option 
			  value="400" 
			  className="fontVarientName" 
			  selected={val.fontWeight === '400'}
			>
			  Regular 400
			</option>
			<option 
			  value="500" 
			  className="fontVarientName" 
			  selected={val.fontWeight === '500'}
			>
			  Medium 500
			</option>
			<option 
			  value="600" 
			  className="fontVarientName" 
			  selected={val.fontWeight === '600'}
			>
			  Semi Bold 600
			</option>
			<option 
			  value="700" 
			  className="fontVarientName" 
			  selected={val.fontWeight === '700'}
			>
			  Bold 700
			</option>
			<option 
			  value="800" 
			  className="fontVarientName" 
			  selected={val.fontWeight === '800'}
			>
			  Extra Bold 800
			</option>
			<option 
			  value="900" 
			  className="fontVarientName" 
			  selected={val.fontWeight === '900'}
			>
			  Black 900
			</option>
		  </>
		);
	  }
	
	  varientField = (FontId, FontFamily, FontType,idx,val,selIndex)=>{
		
		const fontArray = this.state.fonttype.map ((fonttype, index) => ({
		id: index,
		name: fonttype,
		}));

		console.log(fontArray,'this is for font array')
		// Dynamically create select list
		let fonts = [];
		fontArray.map(item =>
			fonts.push({ label: item.name.label, value: item.name.value , fontStyles: item.name.tf_fontStyles, typeIs: item.name.tf_font_type ,type:item.name.type}),
		);
	
		
		let fontWeight = `fontWeight${idx}`,
			FontSize = `FontSize${idx}`,
			FontIndId = `FontId${idx}`,
			letterSpacing = `letterSpacing${idx}`,
			lineHeight = `lineHeight${idx}`,
			TopSpace = `TopSpace${idx}`,
			LgButtonRadius = `lgButtonRadius${idx}`,
			BottomSpace = `BottomSpace${idx}`,
			errorfile = `errorfile${idx}`
			//if(FontType !=='smallButton' && FontType!=='largeButton'){
			return(
				<>
				<div className="form-left">
					<div className="form-group">
						<label>Font Family  :</label>
						<div>																
							

<select
  name="font_id"
  className="form-control"
  id={FontType}
  data-id={idx}
  value={val.font_id?.toString() || ''}
  onChange={(e) => {
	const selectedValue = e.target.value;
	const selectedOption = fonts.find(option => option.value === selectedValue);
	this.handleFileChange(e, idx, selectedOption?.label, selectedOption?.value);
  }}
>
  <option value="">Select Font</option>

  <optgroup label="System Fonts">
	{fonts
	  .filter(f => f.type === 'system_font')
	  .map(option => (
		<option key={option.value} value={option.value}>
		  {option.label}
		</option>
	  ))}
  </optgroup>

  <optgroup label="Google Fonts">
	{fonts
	  .filter(f => f.type === 'google_font')
	  .map(option => (
		<option key={option.value} value={option.value}>
		  {option.label}
		</option>
	  ))}
  </optgroup>
	  {console.log(fonts,'this is for fonts label')}
  <optgroup label="Custom Fonts">
	{fonts
	  .filter(f => f.type === 'normal_font')
	  .map(option => (
		<option key={option.value} value={option.value}>
		  {option.label}
		</option>
	  ))}
  </optgroup>
</select>


							<div className={errorfile}></div> 						
						</div>
					</div>	
				</div>
				<div className="form-right">
					<div className="form-group">
						<label>Font Variant :</label>
						<div>
							<select 
								name="fontWeight" 
								className="form-control" 
								id={FontType} 
								data-id={idx} 
								onChange={(e) => this.handleFileChangeVarients(e, idx)}
							>
								<option value="" className="fontVarientName">Select Variant</option>
									{console.log(this.state.fontDetails,'this is fontsdetails')}
								{this.state.fontDetails[idx]?.variants?.map((variant) => (
									<option 
										key={variant.value} 
										value={variant.value || val.fontWeight} 
										selected={val.fontWeight == variant.value ? true : false}
									>
										{variant.label} {variant.value}
									</option>
								))}
							</select>	
	
							<div className={errorfile}></div>
						</div>
					</div>
				</div>
	
				{/* <div className="form-right">
					<div className="form-group">
						<label>Font Variant :</label>
						<div>
							 <select name="fontWeight" className="form-control" id={FontType} data-id={idx} onChange={(e) => this.handleFileChange(e, idx)}>
							<option value="" className="fontVarientName" > Select Variant</option>
							<option value="200" className="fontVarientName" selected={val.fontWeight=='200'?true:false} > Extra Light200</option>
							<option value="300" className="fontVarientName" selected={val.fontWeight=='300'?true:false}> Light 300</option>
							<option value="400" className="fontVarientName" selected={val.fontWeight=='400'?true:false}> Regular 400</option>
							<option value="500" className="fontVarientName" selected={val.fontWeight=='500'?true:false}> Medium 500</option>
							<option value="600" className="fontVarientName" selected={val.fontWeight=='600'?true:false} > Semi Bold 600</option>
							<option value="700" className="fontVarientName" selected={val.fontWeight=='700'?true:false}> Bold 700</option>
							<option value="800" className="fontVarientName" selected={val.fontWeight=='800'?true:false}> Extra Bold 800</option>
							<option value="900" className="fontVarientName" selected={val.fontWeight=='900'?true:false}>Black 900</option>
											
							</select>	 
	
	
																
							<div className={errorfile}></div> 
						</div>
					</div>	
				</div>	 */}
				<div className="form-left">
					<div className="form-group">
						<label>Font Size  :</label>
						<div>
							<input type="text" name="fontSize" 
							onChange={(e) => this.handleFileChange(e, idx)} 
							//onChange={this.onFileChange}
							value={val.fontSize}
	
							data-id={idx}
							id={FontSize}    /> 
										
							<div className={errorfile}></div> 
						</div>
					</div>	
				</div>
				<div className="form-right">
					<div className="form-group">
						<label>Letter Spacing  :</label>
						<div>
							<input type="text" name="letterSpacing" 
							onChange={(e) => this.handleFileChange(e, idx)} 
							//onChange={this.onFileChange}
							value={val.letterSpacing}
	
							data-id={idx}
							id={letterSpacing}    /> 
										
							<div className={errorfile}></div> 
						</div>
					</div>	
				</div>
				
					{
	
							
						(FontType =='smallButton' || FontType=='largeButton') ?
							<>
							<div className="form-left">
								<div className="form-group">
									<label>Top Space :</label>
									<div>
										<input type="text" name="topSpace" 
										onChange={(e) => this.handleFileChange(e, idx)} 
										value={val.topSpace}
										data-id={idx}
										id={TopSpace}    /> 
													
										<div className={errorfile}></div> 
									</div>
								</div>	
							</div>
							
							<div className="form-right">
								<div className="form-group">
									<label>Bottom Space :</label>
									<div>
										<input type="text" name="bottomSpace" 
										onChange={(e) => this.handleFileChange(e, idx)} 
										value={val.bottomSpace}
										data-id={idx}
										id={BottomSpace}    /> 									
										<div className={errorfile}></div> 
									</div>
								</div>	
							</div>	
							<div className="form-left">
								<div className="form-group">
									<label>Radius :</label>
									<div>
										<input type="text" name="lgButtonRadius" 
										onChange={(e) => this.handleFileChange(e, idx)} 
										value={val.lgButtonRadius}
										data-id={idx}
										id={LgButtonRadius}    /> 
													
										<div className={errorfile}></div> 
									</div>
								</div>	
							</div>
							</>
						: ''
					}
		</>);
	
	}
	varientFieldold2 = (FontId, FontFamily, FontType,idx,val,selIndex)=>{
		console.log(FontType);
		
		console.log('done');
		const fontArray = this.state.fonttype.map ((fonttype, index) => ({
		id: index,
		name: fonttype,
		}));
		// Dynamically create select list
		let fonts = [];
		fontArray.map(item =>
			fonts.push({ label: item.name.label, value: item.name.value , fontStyles: item.name.tf_fontStyles, typeIs: item.name.tf_font_type }),
		);
	
		console.log(fontArray);
	
		let fontWeight = `fontWeight${idx}`,
			FontSize = `FontSize${idx}`,
			FontIndId = `FontId${idx}`,
			letterSpacing = `letterSpacing${idx}`,
			lineHeight = `lineHeight${idx}`,
			TopSpace = `TopSpace${idx}`,
			BottomSpace = `BottomSpace${idx}`,
			errorfile = `errorfile${idx}`
			//if(FontType !=='smallButton' && FontType!=='largeButton'){
			return(
				<>
				<div className="form-left">
					<div className="form-group">
						<label>Font Family  :</label>
						<div>																
							{/* <Select 
								options={fonts}  
								value={FontFamily}
								//onChange={this.handleChangeFont}
								placeholder="Select Font Type" 
								name="FontFamily" 
								id={FontIndId} 
								data-id={idx} 								
								onChange={(e) => this.handleFileChange(e, idx)}
							/> */}
	
							<select name="font_id" className="form-control" id={FontType} data-id={idx} onChange={(e) => this.handleFileChange(e, idx,selIndex)}>
	
							<option value="" className="fontFamilyId" > Select Font</option>						
							{fonts.map((option) => (
							<option key={option.value} value={option.value}  selected={val.font_id==option.value?true:false}>
								{option.label}
							</option>
							))}
							</select>	
							<div className={errorfile}></div> 						
						</div>
					</div>	
				</div>
				<div className="form-right">
					<div className="form-group">
						<label>Font Variant :</label>
						<div>
							 <select name="fontWeight" className="form-control" id={FontType} data-id={idx} onChange={(e) => this.handleFileChange(e, idx)}>
	
							<option value="" className="fontVarientName" > Select Variant</option>
							<option value="200" className="fontVarientName" selected={val.fontWeight=='200'?true:false} > Extra Light200</option>
							<option value="300" className="fontVarientName" selected={val.fontWeight=='300'?true:false}> Light 300</option>
							<option value="400" className="fontVarientName" selected={val.fontWeight=='400'?true:false}> Regular 400</option>
							<option value="500" className="fontVarientName" selected={val.fontWeight=='500'?true:false}> Medium 500</option>
							<option value="600" className="fontVarientName" selected={val.fontWeight=='600'?true:false} > Semi Bold 600</option>
							<option value="700" className="fontVarientName" selected={val.fontWeight=='700'?true:false}> Bold 700</option>
							<option value="800" className="fontVarientName" selected={val.fontWeight=='800'?true:false}> Extra Bold 800</option>
							<option value="900" className="fontVarientName" selected={val.fontWeight=='900'?true:false}>Black 900</option>
											
							</select>	 
	
	
																
							<div className={errorfile}></div> 
						</div>
					</div>	
				</div>	
				<div className="form-left">
					<div className="form-group">
						<label>Font Size  :</label>
						<div>
							<input type="text" name="fontSize" 
							onChange={(e) => this.handleFileChange(e, idx)} 
							//onChange={this.onFileChange}
							value={val.fontSize}
	
							data-id={idx}
							id={FontSize}    /> 
										
							<div className={errorfile}></div> 
						</div>
					</div>	
				</div>
				<div className="form-right">
					<div className="form-group">
						<label>Letter Spacing  :</label>
						<div>
							<input type="text" name="letterSpacing" 
							onChange={(e) => this.handleFileChange(e, idx)} 
							//onChange={this.onFileChange}
							value={val.letterSpacing}
	
							data-id={idx}
							id={letterSpacing}    /> 
										
							<div className={errorfile}></div> 
						</div>
					</div>	
				</div>
					{
						(FontType =='smallButton' || FontType=='largeButton') ?
							<>
							<div className="form-left">
								<div className="form-group">
									<label>Top Space :</label>
									<div>
										<input type="text" name="topSpace" 
										onChange={(e) => this.handleFileChange(e, idx)} 
										value={val.topSpace}
										data-id={idx}
										id={TopSpace}    /> 
													
										<div className={errorfile}></div> 
									</div>
								</div>	
							</div>
							<div className="form-right">
								<div className="form-group">
									<label>Bottom Space :</label>
									<div>
										<input type="text" name="bottomSpace" 
										onChange={(e) => this.handleFileChange(e, idx)} 
										value={val.bottomSpace}
										data-id={idx}
										id={BottomSpace}    /> 									
										<div className={errorfile}></div> 
									</div>
								</div>	
							</div>	
							</>
						: ''
					}
				</>);
			//}
			// if(FontType =='smallButton' || FontType=='largeButton'){
			// 	return(<>
			// 	<div className="form-left">
			// 		<div className="form-group">
			// 			<label>Top Space :</label>
			// 			<div>
			// 				<input type="text" name="TopSpace" 
			// 				onChange={(e) => this.handleFileChange(e, idx)} 
			// 				value={val.topSpace}
			// 				data-id={idx}
			// 				id={TopSpace}    /> 
										
			// 				<div className={errorfile}></div> 
			// 			</div>
			// 		</div>	
			// 	</div>
			// 	<div className="form-right">
			// 		<div className="form-group">
			// 			<label>Bottom Space :</label>
			// 			<div>
			// 				<input type="text" name="BottomSpace" 
			// 				onChange={(e) => this.handleFileChange(e, idx)} 
			// 				value={val.bottomSpace}
			// 				data-id={idx}
			// 				id={BottomSpace}    /> 									
			// 				<div className={errorfile}></div> 
			// 			</div>
			// 		</div>	
			// 	</div>	
			// 	</>);
			// }
	
	}

	
	handleCancel = () => {
		
		const popup = document.querySelector('.input-popup-action');
		if (popup) {
		  popup.classList.remove('show');
		}
	  };
		handleSubmit = () => {
			const popup = document.querySelector('.input-popup-action');
			if (popup) {
			popup.classList.remove('show');
			}
	  };

handleShadowChange = (value) => {
	
	
	this.setState((prevState) => ({
	  shadows: {
		...prevState.shadows,
		[this.state.activeShadowType]: value,
	  },
	}));
  };


			   
	labelFor = (key) => {
		const labels = {
			pluginShadow:'Plugin Shadow', 
			//pluginInset: "Plugin Inside Shadow",
			dashboardShadowGrid:"Dashboard Grid Shadow",
			dashboardShadowList:"Dashboard List Shadow",
			//sideMenu:"Sidemenu Shadow (Side Menu, Chat window)",
			//shortcutMenu: "Shortcut Menu Shadow (Shotcut menu, AI screen textarea)",
			largeButton: "Button Shadow",
			// smallButton: "Small Button Shadow",   
			// sidePopup: "Side Popup Shadow",
			textarea: "Textarea Shadow (Address field)",
			shadowListRow: "List Shadow",
			shadowTableRow: "Table Shadow",
			dropdownmenu: "Dropdown Menu Shadow (Bell notification, Group menu in listing screen, Address dropdown)",
			shadowAISidebar: "AI Sidebar Shadow",

				shadowPluginInsetLeft: "Plugin Inset Left Shadow",
				shadowPluginInsetRight: "Plugin Inset Right Shadow",
				shadowPluginInsetTop: "Plugin Inset Top Shadow",
				shadowPluginInsetBottom: "Plugin Inset Bottom Shadow",
				shadowInput: "Input Box Shadow",
				shadowText: "Text Shadow (Result)",
				shadowLeftSidebar: "Left Sidebar Shadow (Side menu)",
				shadowRightSidebar: "Right Sidebar Shadow (Chat window)",
				shadowMainAITextarea: "AI Screen Textarea Shadow",
				shadowPluginOpenButtonInset: "Open Button Inset Shadow",
			
			};
  return labels[key] || key;
};
		handleInputChangeShadows = (type, value) => {
			console.log(type,'this  type and value',value)
		this.setState((prevState) => ({
			shadows: {
			...prevState.shadows,
			[type]: value
			}
		}));
		};

		handleLandingPageChange = (selectedOption) => {
  this.setState({ landing_page: selectedOption.value });
};
	handlePositionChange = (selectedOption) => {
  this.setState({ st_position: selectedOption.value },()=>{
	if(selectedOption.value =='absolute'){
		$('.d-height').removeClass('d-none');
	}else{
		$('.d-height').addClass('d-none');
	}
  });
};	
  handleChangeTheme = sel => {
		this.setState({ selTheme : sel});
		this.setState({ theme_id : sel.value });
	}	
  render() {
	 const { shadows, activeShadowType,selTheme } = this.state;
	const styles = reactCSS({
	  'default': {
		color: {
		  width: '36px',
		  height: '14px',
		  borderRadius: '2px',
		  background: `${ this.state.hexColor }`,
		},
		swatch: {
		  padding: '5px',
		  background: '#fff',
		  borderRadius: '1px',
		  boxShadow: '0 0 0 1px rgba(0,0,0,.1)',
		  display: 'inline-block',
		  cursor: 'pointer',
		},
		popover: {
		  position: 'absolute',
		  zIndex: '2',
		},
		cover: {
		  position: 'fixed',
		  top: '0px',
		  right: '0px',
		  bottom: '0px',
		  left: '0px',
		},
	  },
	});
	let test1 = this.state.settings_access_code;
	//let test = Number(this.state.settings_access_code);
	
	const scripttype = '';
	
		
	let  tester =	'<script src="https://a-fund.uxt.design/plugin.js"></script> <div data-client="'+test1+'"  id="fund_container"></div>';

	let standAlone =	'<script src="https://a-fund.uxt.design/plugin.js"></script> <div data-client="'+test1+'" id="fund_container" class="fund_standalone"></div>';


	const fontArray = this.state.fonttype.map ((fonttype, index) => ({
	id: index,
	name: fonttype,
	}));
	// Dynamically create select list
	let fonts = [];
	fontArray.map(item =>
	fonts.push({ label: item.name.label, value: item.name.value }),
	);

	const {selectedOption,selectedChatmodule ,selectedFont,selectedfaqmodeluser,selectedfaqmodelguest,selectedfaqmodelcommon ,selectedfaqmodelbroker,selectedfaqmodellender,selectedfaqmodelcompany} = this.state;
	//console.log(selectedOption,"selectedOptionselectedOptionselectedOption")

	const style_text = {
	color: 'white',
	backgroundColor: '#000000',
	padding: '9px 9px',
	minwidth: '49px',
	height: '37px',
	textalign:'center',
	texttransform: 'capitalize'
}
	

		var	lender_preview = (this.state.lender_icon_preview) ? 
		<img className="img_class" src={this.state.lender_icon_preview} alt="" /> :
		<img className="img_class" src={mediaUrl+'settings/'+this.state.old_lender_invite_img} alt="" />;
		var	investor_preview = (this.state.investor_icon_preview) ? 
		<img className="img_class" src={this.state.investor_icon_preview} alt="" /> :
		<img className="img_class" src={mediaUrl+'settings/'+this.state.old_investor_invite_img} alt="" />;

		var	email_icon_preview = (this.state.email_icon_preview) ? 
		<img src={this.state.email_icon_preview} alt="" width="120"/> :
		<img src={mediaUrl+'settings/'+this.state.old_email_header_img} alt="" width="120"/>;

		

		var scalar_icon_preview = (this.state.scalar_icon_preview) ? 
		<img src={this.state.scalar_icon_preview} alt="" width="120"/> :
		<img src={mediaUrl+'settings/'+this.state.old_scalar_icon_img} alt="" width="120"/>;

		//console.log(this.state_lender_invite_desc,"this.state_lender_invite_desc");
	return (
	  <div className="wrapper"> 
 
	  <Header />
	  <MenuSidebar currentpage="setting" />		

	
	<div className="content">	
		<div className="content-wrapper">
		  <div class="content-wrapper-before"></div>
			<div className="content-body setting-main-head leaa-admin-head card">
			<form className="settings" onSubmit={ e => { this.handleFormSubmit(this); e.preventDefault(); }} encType="multipart/form-data">
			<div className="form-wrapper">
			<div className="success_message"></div>
			<div className="title">
				<h4>Settings</h4>
			</div>
			<div className="form-row">
			<div className="form-left">
				<div className="form-group">
				{localStorage.getItem('admin_id') == 1 ?<label>Site Name<span class="required" style={{ color: "red" }} > * </span></label>:<label>Company Name<span class="required" style={{ color: "red" }} > * </span></label>}
					
					<input type="text" name="settings_site_title" onChange={this.handleInputChange} className="form-control" value={this.state.settings_site_title} />
					<div className="errorsettings_site_title"></div>
				</div>
				<div className="form-group">					
					<label>From Name<span class="required" style={{ color: "red" }} > * </span></label>
					<input type="text" name="settings_from_name" onChange={this.handleInputChange} className="form-control"value={this.state.settings_from_name} />
					<div className="errorsettings_from_name"></div>
				</div>
				<div className="form-group">
					<label>From Email<span class="required" style={{ color: "red" }} > * </span></label>
					<input type="text" name="settings_from_email"  onChange={this.handleInputChange} className="form-control" value={this.state.settings_from_email} />
					<div className="errorsettings_from_email"></div>
				</div>
			
				<div className="form-group">
					<label>Inbox email notifications <span style={{fontSize: '15px'}}>(Use comma to add more mails)</span></label>
                    
					<input type="text" name="notification_email"  onChange={this.handleInputChange} className="form-control" value={this.state.notification_email} placeholder='no-reply@lender.market, hello@lender.market'/>

					{/* <textarea  className="form-control " name="notification_email" onChange={this.handleInputChange} placeholder='no-reply@lender.market, hello@lender.market' value={(this.state.notification_email != null)?this.state.notification_email:''} ></textarea> */}
				</div>

				
			
			</div>
			<div className="form-right">

				<div className="form-group">					
					{localStorage.getItem('admin_id') == 1 ? <label>Admin Email<span class="required" style={{ color: "red" }} > * </span></label>:<label>Company Email<span class="required" style={{ color: "red" }} > * </span></label>} 
					<input type="text" className="form-control" onChange={this.handleInputChange} name="settings_admin_email" value={this.state.settings_admin_email} />
					<div className="errorsettings_admin_email"></div>
				</div>
				
				<div className="form-group">
					<label>Contact<span class="required" style={{ color: "red" }} > * </span></label>
					<input type="text" className="form-control" name="settings_mobileno"  onChange={this.handleInputChange} value={this.state.settings_mobileno}/>
					<div className="errorsettings_mobileno"></div>
				</div>

				<div className="form-group"> 
					<label>Email Footer Content<span class="required" style={{ color: "red" }} > * </span></label>
					<input type="text" className="form-control" name="settings_email_footer" onChange={this.handleInputChange} value={this.state.settings_email_footer}/>
					<div className="errorsettings_email_footer"></div>
				</div>

				{/* localStorage.getItem('admin_id') == 1 ? <div className="form-group site-bg-clr"> 
				<label>Site Background Color: </label>
						<div style={ styles.swatch } onClick={ this.handleClick }>
						<div style={ styles.color } />
						</div>
						{ this.state.displayColorPicker ? <div style={ styles.popover }>
						<div style={ styles.cover } onClick={ this.handleClose }/>
						<SketchPicker color={ this.state.color } onChange={ this.handleChange } />
						</div> : null }
				</div> : '' */}

				  
			</div>				
			</div>	

			<div className="title">
				<h4>Mail Configuration Settings</h4>
			</div> 
			
			 <div className="form-group">
					<input className='ms-0' onChange={this.handleInputChange} type="checkbox"  name="settings_mail_from_smtp" checked={this.state.smtp_checked}/>
					<span>Send Mail From Smtp</span>
			</div> 

		 <div className="form-row">
			<div className="form-left">
				<div className="form-group">
					<label>Smtp Host:</label>
					<input type="text" className="form-control" name="settings_smtp_host" onChange={this.handleInputChange}  value={(this.state.settings_smtp_host != 'null')?this.state.settings_smtp_host:''}/>
					<div className="errorsettings_smtp_host"></div>
				</div>
				<div className="form-group">					
					<label>Smtp Username:</label>
					<input type="text" className="form-control" name="settings_smtp_user"  onChange={this.handleInputChange}  value={(this.state.settings_smtp_user != 'null')?this.state.settings_smtp_user:''}  autoComplete='false' />
					<div className="errorsettings_smtp_user"></div>
				</div>					
				<div className="form-group">
					<label>Smtp Password:</label>
					<input type="password" className="form-control" name="settings_smtp_pass" onChange={this.handleInputChange}  value={(this.state.settings_smtp_pass != 'null')?this.state.settings_smtp_pass:''} autoComplete='false' />
				<div className="errorsettings_smtp_pass"></div>
				</div>
			</div>			
			<div className="form-right">
				<div className="form-group">					
					<label>Smtp Port:</label>
					<input type="text" className="form-control"  name="settings_smtp_port" onChange={this.handleInputChange}  value={(this.state.settings_smtp_port != 'null')?this.state.settings_smtp_port:''} />
				<div className="errorsettings_smtp_port"></div>
				</div>
				<div className="form-group"> 
					<label>Mail Path:</label>
					<input type="text" className="form-control" name="settings_mailpath" onChange={this.handleInputChange} placeholder=""  value={(this.state.settings_mailpath != 'null')?this.state.settings_mailpath:''}/>
				</div>

				<div className="form-group">
					<label>Email Header Image</label>
						<div className="choose-file">
							{this.state.isHidden && <div className="image_success"></div>}
							<span className="profile_btn"><input type="file" name="email_header_image" 
							onChange= {this.onChangeHandler.bind(this,'email_header_image')} /></span>
						</div>
						{email_icon_preview}
					<div className="erroremailheader_image"></div>
				</div>
			</div>	
			</div> 
			
			{/* <div className="title">
				<h4>Commision Settings</h4>
			</div>  

			
			<div className="form-row">
			<div className="form-left">
				<div className="form-group">
					<label>Commision Percentage %:</label>
					<input type="text" className="form-control" name="settings_commision_amount" onChange={this.handleInputChange}  value={(this.state.settings_commision_amount != 'null')?this.state.settings_commision_amount:''}/>
					<div className="errorsettings_commision_amount"></div>
				</div>
				</div>
				</div>  */}


				

{this.state.admin_id == 1 && this.state.module_type ==='withlenders' ?<div className="title">
				<h4>Lead Settings</h4>
			</div>:null}

			
			{this.state.admin_id == 1 && this.state.module_type ==='withlenders' ?<div className="form-row">
			<div className="form-left">
				<div className="form-group">
					<label>Merchant Commision To Broker %<span class="required" style={{ color: "red" }} > * </span></label>
					<input type="number" pattern="[0-9.*]" maxlength="5" className="form-control num_valid" name="merchant_commision_to_broker" onChange={this.handleInputChange}  value={(this.state.merchant_commision_to_broker != 'null')?this.state.merchant_commision_to_broker:''}/>
					<div className="errormerchant_commision_to_broker"></div>
				</div>
				<div className="form-group">
					<label>Tax %<span class="required" style={{ color: "red" }} > * </span></label>
					<input type="text"  className="form-control num_valid" name="leads_tax" onChange={this.handleInputChange}  value={(this.state.leads_tax != 'null')?this.state.leads_tax:''}/>
					<div className="errorleads_tax"></div>
				</div>
				</div>

				<div className="form-right">
				<div className="form-group">
					<label>Individual Lead Purchase Limit<span class="required" style={{ color: "red" }} > * </span></label>
					<input type="number" pattern="[0-9.*]" maxlength="3" className="form-control num_valid" name="lender_purchase_count" onChange={this.handleInputChange}  value={(this.state.leads_purchase_amount != 'null')?this.state.lender_purchase_count:''}/>
					<div className="errorlender_purchase_count"></div>
				</div>
				<div className="form-group">
					<label>Leads Purchase Amount $<span class="required" style={{ color: "red" }} > * </span></label>
					<input type="text" className="form-control num_valid" name="leads_purchase_amount" onChange={this.handleInputChange}  value={(this.state.leads_purchase_amount != 'null')?this.state.leads_purchase_amount:''}/>
					<div className="errorleads_purchase_amount"></div>
				</div>
				</div>
				</div>:null}

		{this.state.admin_id == 1 && this.state.module_type ==='withlenders' ?<div className="title">
			<h4>Invite Settings</h4>
		</div>:''}

			{this.state.admin_id == 1 && this.state.module_type ==='withlenders' ?<div className="form-row">
			<div className="form-left">
				<div className="form-group">
					<label>Lender Invitation Description</label>					
					{/* <input type="text"  className="form-control " name="lender_invite_desc" onChange={this.handleInputChange} value={(this.state.lender_invite_desc != null)?this.state.lender_invite_desc:''} /> */}

					<textarea  className="form-control " name="lender_invite_desc" onChange={this.handleInputChange} value={(this.state.lender_invite_desc != null)?this.state.lender_invite_desc:''} ></textarea>
					<div className="errorlender_invite_desc"></div>
				</div>
				<div className="form-group">
					<label>Lender Invitation Template</label>
					<div className="choose-file">
						{this.state.isHidden && <div className="image_success"></div>}
						<span className="profile_btn"><input type="file" name="lender_invite_file" onChange={this.onChangeHandler.bind(this,'lender')} /></span>
					</div>
					{lender_preview}
					<div className="errorlender_invite_template"></div>
				</div>
				</div>

				<div className="form-right">
				
				<div className="form-group">
					<label>Investor Invitation Description</label>
					<textarea  className="form-control " name="investor_invite_desc" onChange={this.handleInputChange} value={(this.state.investor_invite_desc != 'null')?this.state.investor_invite_desc:''} ></textarea>
					<div className="errorinvestor_invite_desc"></div>
				</div>
				<div className="form-group">
					<label>Investor Invitation Template</label>
						<div className="choose-file">
							{this.state.isHidden && <div className="image_success"></div>}
							<span className="profile_btn"><input type="file" name="investor_invite_file" onChange={this.onChangeHandler.bind(this,'investor')} /></span>
						</div>
						{investor_preview}
					<div className="errorinvestor_invite_template"></div>
				</div>
				</div>
				</div>: ''}

				{/* -------------chat ai setting start-------------- */}

			<div className="title">
				<h4>Chat AI Setting</h4>
		   </div> 

			<div className="form-row">
			<div className="form-left">
				{/* <div className="form-group">
					<label>Chat AI type: </label>					
				</div> */}

				<div className="form-group">
					<label>Chat API key</label>					
				</div>

				<div className="form-group">
					<label>Chat Model: </label>					
				</div>

				{/* <div className="form-group">
					<label>Common /Guest Conversation</label>					
				</div>

				<div className="form-group">
					<label>User Conversation</label>					
				</div> */}

				{/* <div className="form-group">
					<label>Broker Conversation</label>					
				</div> */}
				
				{/* {this.state.admin_id == 1 && this.state.module_type ==='withlenders' ?<div className="form-group">
					<label>Lender Conversation</label>					
				</div>:null}
				<div className="form-group">
					<label>Company Conversation</label>					
				</div> */}
				
			</div> 
			<div className="form-right">
			{/* <div className="form-group">						
				<input onChange={this.handleInputChange} type="radio" name="aichat_type" checked={this.state.aichat_type=='text'?'chekced':''} value="text"/>
				<span>Text</span>
					<input onChange={this.handleInputChange} type="radio"  name="aichat_type" checked={this.state.aichat_type=='chat'?'chekced':''} value="chat"/>
				<span>Chat </span>
			</div>  */}

			<div className="form-group">						
				<input onChange={this.handleInputChange}  type="text" name="chat_api_key" value={this.state.chat_api_key}/>
				
			</div> 

			<div className="form-group">					
				
				<Select 
					className="z-index-999"
					options={this.state.faqmodelcommon}  
					value={selectedfaqmodelcommon?selectedfaqmodelcommon:{ value: '0', label: 'Select an ai model' }}
					onChange={this.handleChangeAimodelcommon}
					placeholder="Select AI Model ID" 
				/>			
			</div>

			{/* <div className="form-group">					
				
				<Select 
					options={this.state.faqmodelguest}  
					value={selectedfaqmodelguest?selectedfaqmodelguest:{ value: '0', label: 'Select guest ai model' }}
					onChange={this.handleChangeAimodelguest}
					placeholder="Select AI Model ID" 
				/>			
			</div>

			<div className="form-group">					
				<Select 
					options={this.state.faqmodeluser}  
					value={selectedfaqmodeluser?selectedfaqmodeluser:{ value: '0', label: 'Select user ai model' }}
					onChange={this.handleChangeAimodeluser}
					placeholder="Select AI Model ID" 
				/>			
			</div>			 */}

			{/* <div className="form-group">					
				<Select 
					options={this.state.faqmodelbroker}  
					value={selectedfaqmodelbroker?selectedfaqmodelbroker:{ value: '0', label: 'Select broker ai model' }}
					onChange={this.handleChangeAimodelbroker}
					placeholder="Select AI Model ID" 
				/>			
			</div>	 */}
			{/* {this.state.admin_id == 1 && this.state.module_type ==='withlenders' ?<div className="form-group">					
				<Select 
					options={this.state.faqmodellender}  
					value={selectedfaqmodellender?selectedfaqmodellender:{ value: '0', label: 'Select lender ai model' }}
					onChange={this.handleChangeAimodellender}
					placeholder="Select AI Model ID" 
				/>			
			</div>:null}
			<div className="form-group">					
				<Select  
					options={this.state.faqmodelcompany}  
					value={selectedfaqmodelcompany?selectedfaqmodelcompany:{ value: '0', label: 'Select company ai model' }}
					onChange={this.handleChangeAimodelcompany}
					placeholder="Select AI Model ID" 
				/>			
			</div>	 */}
			
			
			</div>
		</div>
		{/* -------------chat ai setting end-------------- */}
		<div className="title">
				<h4>Feed domain data</h4>
		</div>

		<div className="form-group">					
					<label>Type</label>
						   <input type="radio" name='type' value="text" onChange={this.handleInputChange} checked={this.state.completion_type === 'text'} /> Prompt Text  
						   <input type="radio" name='type' value="chat" onChange={this.handleInputChange} checked={this.state.completion_type === 'chat'}/> Assistant Chat  
			   </div>  
		
		<div className="form-group">	
					
						{/* <textarea type="text" name='description' onChange={this.handleInputChange} className='form-control' value={this.state.description} /> */}
						<CKEditor
  key={this.state.finetune_content ? 'finetune' : 'desc'}
  data={this.state.finetune_content !== null && this.state.finetune_content !== undefined
	? this.state.finetune_content
	: this.state.description}
  onChange={this.onEditorAIChange}
  type="classic"
/>

					<div className="errordescription"></div>
					<button className='ai-feedbtn' onClick={this.handleSave}>AI Feed</button>
				</div>		
		
			 

		{/*AI Teaching******************************* start */}

		  {/*Bank statement settings start */}

		
		
			   {/*Bank statement settings end */}

		
		<div className="title">
				<h4>Domain & Embed Code</h4>
		</div> 
		<div className="form-row">
				<div className="form-left">
				    <div className="form-group">
						<label>Embed Code</label>
						<p className="right-side-header"  id="embed_code" name="settings_embedcode" value={tester} title="Copy Text" >{tester}</p>
						<br></br>
						<a id='copytext' style={style_text} onClick={this.writeText}   >Copy  </a> <br></br>
						<div><br></br><div className="copied_title"></div></div>
						<div className="errorsettings_embedcode_title"></div>
					</div>

					<div className="form-group">
						<label>Standalone Code</label>
						<p className="right-side-header" id="standalone_code" name="settings_standalonecode" value={standAlone} title="Copy Text" >{standAlone}</p>
						<br></br>
						<a id='copytext' style={style_text} onClick={this.writeStandaloneText} >Copy  </a> <br></br>
						<div><br></br><div className="copied_title"></div></div>
						<div className="errorsettings_standalone_code_title"></div>
					</div>
					
					<div className='form-group'>
					 <h4>Google Analytics code </h4>
					 <textarea type="text" name="google_analystic_code" onChange={this.handleInputChange} className="form-control" value={this.state.google_analystic_code} />
					</div>
				</div>	
				<div className="form-right">
					<div className='form-group'>
					 <h4>Domain<span class="required" style={{ color: "red" }} > * </span></h4>
					<div className="domain-url">
					<Addinputsimple myCallback={this.myCallback} domainname={this.state.domainSets} count_domain={this.state.count_domain}/>
					</div>
					<div className="errorsettings_domain"></div>
					</div>
				</div>				
			</div>
				<div className='form-row mb-0'>
					<div className="form-left">
						<div className="form-group">
							<label>Plugin Position:</label><br/>
							<Select
							name="st_position"
							value={lang.common.pluginPosition.find(
								option => option.value === this.state.st_position
							)}
							options={lang.common.pluginPosition}
							onChange={this.handlePositionChange}
							/>
						</div>
					</div>
					<div className="form-right">
						<div className="form-group d-height d-none">
							<label>Plugin Height</label>
							<input type="text" className="form-control" name="st_plugin_height"  onChange={this.handleInputChange} value={this.state.st_plugin_height}/>
							<div className="errorst_st_plugin_height"></div>
						</div>
					</div>
				</div>
							 
			 <div className="form-row">			
				<div className="form-left">
							
					<div className="form-group">
						<label>Top (%):</label>
						<input type="text" className="form-control" name="st_position_top"  onChange={this.handleInputChange} value={this.state.st_position_top}/>
						<div className="errorsettings_st_position_top"></div>
					</div>
					<div className="form-group">
						<label>Bottom (%):</label>
						<input type="text" className="form-control" name="st_position_bottom"  onChange={this.handleInputChange} value={this.state.st_position_bottom}/>
						<div className="errorsettings_st_position_bottom"></div>
					</div>
					{/* <div className="form-group">
						<label>Position  </label>
						<input onChange={this.handleInputChange} type="checkbox"  name="st_position" checked={this.state.st_position_checked}/>
						<span>Fixed</span>
					</div> */}
					
					 {/* {this.state.admin_id == 1 && this.state.module_type ==='withlenders' ?	<div className="form-group">
						<label>Enable Maintab</label>
						<input onChange={this.handleInputChange} type="radio" name="enable_maintab" checked={this.state.maintab_enable_yes}/>
						<span>Yes</span>
						 <input onChange={this.handleInputChange} type="radio"  name="enable_maintab" checked={this.state.maintab_enable_no}/>
						<span>No</span>
					</div>:null} */}
					 {/* {this.state.admin_id == 1 && this.state.module_type ==='withlenders' ?	<div className="form-group">
						<label>Plugin Landing Page</label><br/>					    
						 <input onChange={this.handleInputChange} type="radio"  name="landing_page" checked={this.state.landing_page === "MainTab"} value="MainTab"/>
						<span>Main</span>
						<input onChange={this.handleInputChange} type="radio"  name="landing_page" checked={this.state.landing_page === "Ads"} value="Ads"/>
						<span>Ads</span>
						<input onChange={this.handleInputChange} type="radio"  name="landing_page" checked={this.state.landing_page === "LeadForm"} value="LeadForm"/>
						<span>Lead form</span>
						<input onChange={this.handleInputChange} type="radio" name="landing_page" checked={this.state.landing_page === "InnerTab"} value="InnerTab" />
						<span>Off</span>
					</div>:null} */}

					
					 
				</div>
				<div className="form-right">					
					<div className="form-group">
						<label>Left (%):</label>
						<input type="text" className="form-control" name="st_position_left"  onChange={this.handleInputChange} value={this.state.st_position_left}/>
						<div className="errorsettings_st_position_left"></div>
					</div>
					<div className="form-group">
						<label>Right (%):</label>
						<input type="text" className="form-control" name="st_position_right"  onChange={this.handleInputChange} value={this.state.st_position_right}/>
						<div className="errorsettings_st_position_right"></div>
					</div>
					




		
				</div>
				
			</div> 

			<div>
				<h5>Plugin Inner Space:</h5>
			</div>
			 <div className="form-row">			
				<div className="form-left">	
					<div className="form-group">
						<label>Top (px):</label>
						<input type="number" className="form-control" name="st_inner_position_top"  onChange={this.handleInputChange} value={this.state.st_inner_position_top}/>
						<div className="errorsettings_st_inner_position_top"></div>
					</div>
					<div className="form-group">
						<label>Bottom (px):</label>
						<input type="number" className="form-control" name="st_inner_position_bottom"  onChange={this.handleInputChange} value={this.state.st_inner_position_bottom}/>
						<div className="errorsettings_st_inner_position_bottom"></div>
					</div>
				</div>
				<div className="form-right">
					<div className="form-group">
						<label>Left (px):</label>
						<input type="number" className="form-control" name="st_inner_position_left"  onChange={this.handleInputChange} value={this.state.st_inner_position_left}/>
						<div className="errorsettings_st_inner_position_left"></div>
					</div>
					<div className="form-group">
						<label>Right (px):</label>
						<input type="number" className="form-control" name="st_inner_position_right"  onChange={this.handleInputChange} value={this.state.st_inner_position_right}/>
						<div className="errorsettings_st_inner_position_right"></div>
					</div>
					

				</div>
			</div> 
			<div className="form-row">	
				<div className="form-left">

						{this.state.admin_id == 1 && this.state.module_type ==='withlenders' ?	<div className="form-group">
						<label>Show category icons:</label>
						<input onChange={this.handleInputChange} type="radio" name="category_icons" checked={this.state.category_icons_yes}/>
						<span>Yes</span>
						 <input onChange={this.handleInputChange} type="radio"  name="category_icons" checked={this.state.category_icons_no}/>
						<span>No</span>
					</div>:null}

							{this.state.admin_id == 1 && this.state.module_type === 'withlenders' ? (
					<div className="form-group">
						<label>Plugin Landing Page:</label><br/>
						<Select
						name="landing_page"
						value={lang.common.landingPageOptions.find(
							option => option.value === this.state.landing_page
						)}
						options={lang.common.landingPageOptions}
						onChange={this.handleLandingPageChange}
						/>
					</div>
					) : null}

					

					 <div className="form-group">
						<label>Show Shortcut Icons: </label>
							<input onChange={this.handleInputChange} type="radio" name="show_shortcut" checked={this.state.shortcut_icons_yes}  />
							<span>Yes</span>
							<input onChange={this.handleInputChange} type="radio" name="show_shortcut"  checked={this.state.shortcut_icons_no} />
							<span>No</span>
					</div>
					
					<div className="form-group">
						<label>Notification Popup Theme </label>
						<input onChange={this.handleInputChange} type="radio" name="np_theme" value="Black" checked={(this.state.np_theme == "Black" ? "checked" : "" )}/>
						<span>Black bg with White text</span>
						 <input onChange={this.handleInputChange} type="radio"  name="np_theme" value="White" checked={(this.state.np_theme == "White" ? "checked" : "" )}/>
						<span>White bg with Black text</span>
					</div> 					

					<div className="form-group">					
						<label>Terms and Conditions</label>
						<CKEditor
						data={this.state.terms_and_condition}
						//data={templatecontent}
						onChange={this.onEditorChange}
						type="classic"
						/>
						<div className="errorlogo_content"></div>
					</div>

				     <div className="form-group">
						<label>Factor Rate:</label>
						<input type="number" className="form-control" name="st_factor_rate"  onChange={this.handleInputChange} value={this.state.st_factor_rate}/>
						<div className="st_factor_rate"></div>
					</div>

				</div>
							
				<div className="form-right">
							{this.state.admin_id == 1 && this.state.module_type ==='withlenders' ? <div className="form-group">
						<label>Header category limit: </label>
						<input type="number" className="form-control" name="header_cat_limit"  onChange={this.handleInputChange} value={this.state.header_cat_limit}/>
						{/* <div className="errorsettings_st_position_bottom"></div> */}
					</div>:null}

					{this.state.admin_id == 1 && this.state.module_type ==='withlenders' ?<div className="form-group">
						<label>Invite Friends (%):</label>
						<input type="number" className="form-control" name="invite_friends_perc"  onChange={this.handleInputChange} value={this.state.invite_friends_perc}/>
						<div className="errorinvite_friends_perc"></div>
					</div>:null}
						<div className="form-group">					
					<label> Plugin width:</label>
						   <Select name="plugin_width"
						   value={selectedOption}
							options={lang.common.pluginWidth_option} 
							onChange={this.handleChangeWidth}
							isSearchable={false}
							/>
					<div className=""></div>
					</div>
					<div className="form-group">
						<label>Guest User File Upload limit: </label>
						<input type="number" className="form-control" name="guestuserfileupload"  onChange={this.handleInputChange} value={this.state.guestuserfileupload}/>
						{/* <div className="errorsettings_st_position_bottom"></div> */}
					</div>

							 <div className="form-group">
						<label>User File Upload limit: </label>
						<input type="number" className="form-control" name="userfileupload"  onChange={this.handleInputChange} value={this.state.userfileupload}/>
						{/* <div className="errorsettings_st_position_bottom"></div> */}
					</div>
					<div className="form-group">
						<label>Book Keeping File Upload limit: </label>
						<input type="number" className="form-control" name="book_keepingfileupload"  onChange={this.handleInputChange} value={this.state.book_keepingfileupload}/>
						{/* <div className="errorsettings_st_position_bottom"></div> */}
					</div>

					<div className="form-group">
						<input className='ms-0' onChange={this.handleInputChange} type="checkbox"  name="st_outer_space" checked={this.state.st_outer_space_checked}/>
						<label>Plugin outer space in mobile:</label>
					</div>

					
						 <div className="form-group">
						<label>AI Json Update: </label>
							<input onChange={this.handleInputChange} type="radio" name="json_update" checked={this.state.json_update_yes}  />
							<span>Yes</span>
							<input onChange={this.handleInputChange} type="radio" name="json_update"  checked={this.state.json_update_no} />
							<span>No</span>
					</div>

					 <div className="form-group">
                        <label>Dashboard View: </label>
                        <input
                          onChange={this.handleInputChange}
                          type="radio"
                          name="dashboard_view"
                          value="true"
                          checked={
                            this.state.dashboard_view == "true" ? "checked" : ""
                          }
                        />
                        <span>List</span>
                        <input
                          onChange={this.handleInputChange}
                          type="radio"
                          name="dashboard_view"
                          value="false"
                          checked={
                            this.state.dashboard_view == "false" ? "checked" : ""
                          }
                        />
                        <span>Grid</span>
                      </div>

					  <div className="form-group">
                        <label>Lead View: </label>
                        <input
                          onChange={this.handleInputChange}
                          type="radio"
                          name="lead_view"
                          value="true"
                          checked={
                            this.state.lead_view == "true" ? "checked" : ""
                          }
                        />
                        <span>List View</span>
                        <input
                          onChange={this.handleInputChange}
                          type="radio"
                          name="lead_view"
                          value="false"
                          checked={
                            this.state.lead_view == "false" ? "checked" : ""
                          }
                        />
                        <span>Table View</span>
                      </div>
					
					
				</div>
			</div>
				<h4>Scalar Icon</h4>
             
				<div className="form-row">			
					<div className="form-left">	
						<div className="form-group">
						<label>Upload Scalar Icon</label>
						<div className="choose-file">
							{this.state.isHidden && <div className="image_success"></div>}
							<span className="profile_btn"><input type="file" name="scalar_icon_image" onChange={this.onChangeHandler.bind(this,'scalar_icon')} /></span>
						</div>
						{scalar_icon_preview}
						<div className="errorscalarimage"></div>
					</div>
				</div>
				<div className="form-right">
					<div className="form-group">
						<label>Max width (px):</label>
						<input type="number" className="form-control" name="st_scalar_width"  onChange={this.handleInputChange} value={this.state.st_scalar_width}/>
						<div className="errorscalarwidth"></div>
					</div>
					<div className="form-group">
						<label>Max height (px):</label>
						<input type="number" className="form-control" name="st_scalar_height"  onChange={this.handleInputChange} value={this.state.st_scalar_height}/>
						<div className="errorscalarheight"></div>
					</div>
					

				</div>
			</div> 

			{this.state.admin_id == 1 && this.state.module_type ==='withlenders' ?  <div className="title">
				<h4>Stripe Configuration</h4>
		   </div>:null}
		   {this.state.admin_id == 1 && this.state.module_type ==='withlenders' ? <div className="form-group">
					<input onChange={this.handleInputChange} type="radio" name="settings_enable_live" checked={this.state.stripe_live_checked}/>
					<span>Live</span>
					 <input onChange={this.handleInputChange} type="radio"  name="settings_enable_sandbox" checked={this.state.stripe_sandbox_checked}/>
					<span>SandBox</span>
			</div>:null}
			{this.state.admin_id == 1 && this.state.module_type ==='withlenders' ?<div className="form-row">
			<div className="form-left">
				<div className="form-group">
					<label>Public Key<span class="required" style={{ color: "red" }} > * </span></label>
					<input type="text" className="form-control" name="settings_public_key" onChange={this.handleInputChange}  value={this.state.settings_public_key}/>
					<div className="errorsettings_public_key"></div>
				</div>

				<div className="form-group">
					<label>Product Key<span class="required" style={{ color: "red" }} > * </span></label>
					<input type="text" className="form-control" name="settings_product_key" onChange={this.handleInputChange}  value={this.state.settings_product_key}/>
					<div className="errorsettings_product_key"></div>
					<span>Note : For Recurring payment(Monthly) the product key use.</span>
				</div>
					
			</div>	
			<div className="form-right">
				
				<div className="form-group">					
					<label>Secret Key<span class="required" style={{ color: "red" }} > * </span></label>
					<input type="password" className="form-control" name="settings_secret_key"  onChange={this.handleInputChange}  value={this.state.settings_secret_key} />
					<div className="errorsettings_secret_key"></div>
				</div>	

			</div>	

		</div>:null}	

		  <div className="title">
				<h4>Chat Module Settings</h4>
			</div> 
			<div className="form-row">		
			<div className="form-left">
			  <div className="default-font">
					<div className="form-group">
						<label>Select Model  :</label>
					</div>
				</div> 
			</div>

			<div className="form-right">	
				<div className="form-group">
						<Select 
							options={this.state.all_models}  
							value={selectedChatmodule?selectedChatmodule:{ value: '0', label: 'Select AI model' }}
							onChange={this.handleChangeChatModule}
							placeholder="Select AI model"
						/>
						<div className="errorfont"></div>
				</div>
			</div>	
			</div>
		

		{/* <div className="title">
				<h4>AI Sidebar Management</h4> 
				</div>
			 
					 <div className="form-row">			
				<div className="form-left">	
					<div className="form-group">
						<label>Sidebar Collapsed size (px):</label>
						<input type="number" className="form-control" name="st_aisidebar_collapsed_width"  onChange={this.handleInputChange} value={this.state.st_aisidebar_collapsed_width}/>
						<div className="errorsettings_st_aisidebar_collapsed_width"></div>
					</div>
					<div className="form-group ">
						<label>Icon size (px): </label>
						<input type="number" className="form-control" name="st_aisidebar_icon_width"  onChange={this.handleInputChange} value={this.state.st_aisidebar_icon_width}/>
						<div className="errorst_st_plugin_height"></div>
					</div>
				</div>
				<div className="form-right">
					<div className="form-group">
						<label>Sidebar Expended size (px):</label>
						<input type="number" className="form-control" name="st_aisidebar_main_width"  onChange={this.handleInputChange} value={this.state.st_aisidebar_main_width}/>
						<div className="errorsettings_st_aisidebar_main_width"></div>
					</div>										
					
				</div>
			</div> 	 */}
			
			{/* <div className="title">
				<h4>Radius Management</h4>
			</div> 
			<div className="form-row">
				<div className="form-left">
					<div className="form-group">
						<label>Plugin Radius (px):</label>
						<input type="text" className="form-control" name="st_plugin_radius"  onChange={this.handleInputChange} value={this.state.st_plugin_radius}/>
						<div className="errorst_plugin_radius"></div>
					</div>					
					<div className="form-group">
						<label>Input Box Radius (px):</label>
						<input type="text" className="form-control" name="inputRadius"  onChange={this.handleInputChange} value={this.state.inputRadius}/>
						<div className="errorinputRadius"></div>
					</div>					
				</div>
				<div className="form-right">
					<div className="form-group">
						<label>Dropdown Menu Radius (px) (Bell notification, Grouping menu listing, Address Dropdown):</label>
						<input type="text" className="form-control" name="st_dropdown_menu_radius"  onChange={this.handleInputChange} value={this.state.st_dropdown_menu_radius}/>
						<div className="errorst_dropdown_menu_radius"></div>
					</div>
					<div className="form-group">
						<label>Textarea Radius (px) (AI Screen Textarea, Bank statement summary):</label>
						<input type="text" className="form-control" name="textareaRadius"  onChange={this.handleInputChange} value={this.state.textareaRadius}/>
						<div className="errortextareaRadius"></div>
					</div>
				</div>
			</div> */}

			{/* <div className="title">
				<h4>Shadow Management</h4>
			</div>  */}
			{/* <div className="form-row">
					{Object.entries(this.state.shadows).map(([key, value]) => (
						<div className="form-left" key={key}>
						<div className="form-group admin-panel-btn">
							<label>{this.labelFor(key)}:</label>
							<input
								value={value}
								type="text"
								autoComplete="off"
								className="form-control"
								style={{ width: "85%" }}
								onChange={(e) => this.handleInputChangeShadows(key, e.target.value)}
							/>
							<button
								type="button"
								onClick={() => this.confirmPopup(key)}
								style={{
									color: "white",
									padding: "14px",
									minWidth: "47px",
									height: "48px",
									backgroundColor: "rgb(5, 31, 58)",
									borderRadius: "0px 5px 5px 0px"
								}}
							>
							<i><svg xmlns="http://www.w3.org/2000/svg" fill="#fff" viewBox="32 -0.03 543.87 512.03"><path d="M339.3 367.1c27.3-3.9 51.9-19.4 67.2-42.9L568.2 74.1c12.6-19.5 9.4-45.3-7.6-61.2S517.7-4.4 499.1 9.6L262.4 187.2c-24 18-38.2 46.1-38.4 76.1L339.3 367.1zm-19.6 25.4l-116-104.4C143.9 290.3 96 339.6 96 400c0 3.9 .2 7.8 .6 11.6C98.4 429.1 86.4 448 68.8 448L64 448c-17.7 0-32 14.3-32 32s14.3 32 32 32l144 0c61.9 0 112-50.1 112-112c0-2.5-.1-5-.2-7.5z"></path></svg></i>
							</button>
						</div>
						</div>
					))}
					</div> */}
					{/* <div className="form-row">	
				
					<div className="input-popup-action">
								<a className="popup-close position-absolute cursor-pointer" onClick={this.handleCancel}>
								X
								</a>
								<div className="title">
									<h4 style={{ fontSize: "30px" }}>
									{this.labelFor(this.state.activeShadowType)}
									</h4>
								</div>

									<div className="shadow-picker-container d-flex w-100 justify-content-between">
										<ShadowPicker
										value={this.state.shadows[this.state.activeShadowType] || ''}
										onChange={(value) => this.handleShadowChange(value)}
										className="shadow-picker"
										/>

										<div className="shadow-box" style={{ boxShadow: this.state.shadows[this.state.activeShadowType] || 'none' }}></div>


										
									</div>
									<div className="d-flex w-100 justify-content-end gap-2 mt-5">
										<button className="primary-btn" onClick={this.handleSubmit}>
										Save
										</button>										
									</div>
					</div>
			</div>	 */}
		  {/* <div className="title">
				<h4>Font Management</h4>
			</div> 
			<div className="form-row">	
				<div className="form-left">					
					<div className="form-group">
						<label>Line Height</label>
						<input type="text" className="form-control" name="lineHeight" onChange={this.handleInputChange}  value={this.state.lineHeight}/>
						<div className="errorlineHeight"></div>
					</div>
				</div>	
			</div>	
			{this.addMoreFunc()}	
			 */}

			<div className="title">
				<h4>Terms and Conditions</h4>
			</div> 

			<div className="form-row">
				<div className="form-left">
					<div className="form-group">
						<label>Terms of Service</label>				

						<CKEditor
							data={this.state.terms_services}
							onChange={(event) =>
								this.onEditorTermsChange('terms_services', event)
							}
							type="classic"
						/>
						<div className="error_terms_of_service"></div>
					</div>

					<div className="form-group">
						<label>Captial Provider</label>				

						<CKEditor
							data={this.state.capital_provider}
							 onChange={(event) =>
								this.onEditorTermsChange('capital_provider', event)
							}
							type="classic"
						/>
						<div className="error_terms_of_service"></div>
					</div>

					<div className="form-group">
						<label>Privacy Policy</label>				

						<CKEditor
							data={this.state.privacy_policy}
							onChange={(event) =>
								this.onEditorTermsChange('privacy_policy', event)
							}
							type="classic"
						/>
						<div className="error_terms_of_service"></div>
					</div>
					
					</div>

					<div className="form-right">
						<div className="form-group">
							<label>Borrower Terms</label>
							<CKEditor
								data={this.state.borrower_terms}
								onChange={(event) =>
									this.onEditorTermsChange('borrower_terms', event)
								}
								type="classic"
							/>
							<div className="errorborrower_terms"></div>
						</div>
						<div className="form-group">
							<label>Crypto Terms</label>
							<CKEditor
								data={this.state.crypto_terms}
								onChange={(event) =>
									this.onEditorTermsChange('crypto_terms', event)
								}
								type="classic"
							/>
							<div className="errorcrypto_terms"></div>
						</div>
						<div className="form-group">
							<label>Disclosure Policy Terms</label>
							<CKEditor
								data={this.state.disclosure_policy_terms}
								onChange={(event) =>
									this.onEditorTermsChange('disclosure_policy_terms', event)
								}
								type="classic"
							/>
							<div className="errorcrypto_terms"></div>
						</div>
					</div>
				</div>


			<div className="title">
                          <h4>Theme Management</h4>
                        </div> 
                        
                        <div className="form-row">		
                          <div className="form-left">
                            <div className="default-font">
                              <div className="form-group">
                                <label>Theme :</label>
                                <Select 
                                  options={this.state.themeData}  
                                  value={selTheme?selTheme:{ value: '0', label: 'Select Theme' }}
                                  onChange={this.handleChangeTheme}
                                  placeholder="Select theme"
                                />
                                <div className="errortheme"></div>
                              </div>
                            </div> 
                          </div> 
                        </div>	

			<div className="btn-group export">	
				
				<button className="btn btn_orange btn_minwid login_submit animate-btn2" type="submit" disabled={(this.state.Loading ===true)?true:false}> {this.state.Loading ===true &&
								<span className="load-data">Loading</span> 
								} Submit
				</button>	
			</div>

			</div>
			</form>
			</div>	
		</div>	
	</div>
			
	</div>
	);
  }
}

export default (withRouter(Setting));